<template>
  <v-data-table
    :headers="headers"
    :items="lols"
    sort-by="lolNumber"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="lolNumber"
    multi-sort
    show-expand
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn
          v-if="checkRole('lf')"
          color="primary"
          dark
          class="mb-2"
          @click="clearCalibrationSheet()"
        >
          New Calibration
        </v-btn>

        <v-bottom-sheet v-model="calibrationSheet" scrollable>
          <v-card>
            <v-tabs
              v-model="calibrationTab"
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#tab-1">
                Recall Ticket
                <v-icon>mdi-ticket-percent</v-icon>
              </v-tab>

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="closeCalibrationSheet()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-tabs>

            <v-card-text height="500">
              <v-tabs-items v-model="tab">
                <v-tab-item value="tab-1" eager>
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            Recall Ticket
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="lolSheet" scrollable>
          <v-card>
            <v-tabs
              v-model="tab"
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">
                LOL
                <v-icon>mdi-tablet-cellphone</v-icon>
              </v-tab>

              <v-tab
                v-if="editedItem.unitShow && checkRole('lf')"
                href="#tab-2"
              >
                Unit
                <v-icon>mdi-briefcase-outline</v-icon>
              </v-tab>

              <v-tab
                v-if="
                  !editedItem.unitShow &&
                    checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])
                "
                href="#tab-2a"
              >
                Add Unit
                <v-icon>mdi-plus</v-icon>
              </v-tab>

              <v-tab
                v-if="
                  editedItem.parts && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])
                "
                href="#tab-3"
              >
                Parts
                <v-icon>mdi-memory</v-icon>
              </v-tab>

              <v-tab
                v-if="
                  editedItem.unitShow &&
                    !editedItem.parts &&
                    checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])
                "
                @click="editedItem.parts = true"
                href="#tab-3"
              >
                Add Parts
                <v-icon>mdi-plus</v-icon>
              </v-tab>

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(true)"
                v-if="
                  !editMode &&
                    !editModeDealer &&
                    checkRole([
                      'ROLE_LFADMIN',
                      'ROLE_LFTECH',
                      'ROLE_DEALERADMIN'
                    ])
                "
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(false)"
                v-if="editMode || editModeDealer"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-tabs>

            <v-card-text height="500">
              <v-tabs-items v-model="tab">
                <v-tab-item value="tab-1" eager>
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.lolNumber"
                              label="LOL Number"
                              color="cyan"
                              :rules="rules.required"
                              required
                              hint="Required"
                              persistent-hint
                              :readonly="!editMode"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.lolName"
                              label="LOL Nickname"
                              color="cyan"
                              :readonly="!editMode"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="6" v-if="checkRole('lf')">
                            <v-autocomplete
                              v-model="editedItem.customerID"
                              label="Dealer"
                              :items="dealers"
                              item-text="customerName"
                              item-value="customerID"
                              color="cyan"
                              item-color="cyan"
                              @change="refreshLocations(editedItem.customerID)"
                              :selected="editedItem.customerID"
                              :readonly="!editMode"
                            ></v-autocomplete>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-autocomplete
                              v-model="editedItem.locationID"
                              label="Location"
                              :items="locations"
                              item-text="locationName"
                              item-value="locationID"
                              color="cyan"
                              item-color="cyan"
                              :selected="editedItem.locationID"
                              :disabled="!editedItem.customerID"
                              :readonly="!editMode"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-if="checkRole('lf')"
                              v-model="editedItem.calibrationDate"
                              label="Next Calibration Date"
                              color="cyan"
                              readonly
                            >
                              <template v-slot:append-outer>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      @click="openCalibrationDialog()"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon>mdi-tools</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Perform Calibration</span>
                                </v-tooltip>
                              </template>
                            </v-text-field>

                            <v-text-field
                              v-else
                              v-model="editedItem.calibrationDate"
                              label="Next Calibration Date"
                              color="cyan"
                              readonly
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6" v-if="checkRole('lf')">
                            <v-textarea
                              v-model="editedItem.lolNotes"
                              rows="2"
                              color="blue-grey"
                              :readonly="!editMode"
                              filled
                              auto-grow
                              background-color="orange lighten-4"
                            >
                              <template v-slot:label>
                                <div>
                                  LOL Notes <small>(LF Internal)</small>
                                </div>
                              </template>
                            </v-textarea>
                          </v-col>
                        </v-row>

                        <v-expansion-panels v-if="checkRole('lf')">
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              color="cyan"
                              class="white--text"
                            >
                              <div>Technical <small>(LF Internal)</small></div>
                              <template v-slot:actions>
                                <v-icon color="white">
                                  $expand
                                </v-icon>
                              </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <v-container>
                                <v-row dense>
                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="editedItem.lastPowerOnShow"
                                      label="Last Power On"
                                      color="cyan"
                                      readonly
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="editedItem.lastSyncShow"
                                      label="Last Sync"
                                      color="cyan"
                                      readonly
                                    ></v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="editedItem.commissionDateShow"
                                      label="Commission Date"
                                      color="cyan"
                                      readonly
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="editedItem.decommissionDateShow"
                                      label="Decommission Date"
                                      color="cyan"
                                      readonly
                                    >
                                      <template v-slot:append-outer>
                                        <v-tooltip top>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              icon
                                              @click="
                                                dialogDecommissionLol = true
                                              "
                                              :disabled="
                                                editedItem.decommissionDate !=
                                                  null
                                              "
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>mdi-robot-dead</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Decommission LOL</span>
                                        </v-tooltip>
                                      </template>
                                    </v-text-field>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col cols="12" sm="6">
                                    <v-switch
                                      v-model="editedItem.debugMode"
                                      label="Debug Mode"
                                      color="cyan"
                                      :readonly="!editMode"
                                    ></v-switch>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="close">
                            Cancel
                          </v-btn>
                          <v-btn color="cyan" dark @click="save">
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="editedItem.unitShow && checkRole('lf')"
                  value="tab-2"
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" lg="8" offset-lg="2">
                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-text-field
                                  v-model="editedItem.unit.unitNumber"
                                  label="Unit Number"
                                  color="cyan"
                                  :rules="rules.required"
                                  required
                                  hint="Required"
                                  persistent-hint
                                  :readonly="!editMode"
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="6">
                                <v-textarea
                                  v-model="editedItem.unit.unitNotes"
                                  rows="2"
                                  color="blue-grey"
                                  :readonly="!editMode"
                                  filled
                                  auto-grow
                                  background-color="orange lighten-4"
                                >
                                  <template v-slot:label>
                                    Unit Notes
                                  </template>
                                </v-textarea>
                              </v-col>
                            </v-row>

                            <v-expansion-panels>
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  color="cyan"
                                  class="white--text"
                                >
                                  Technical
                                  <template v-slot:actions>
                                    <v-icon color="white">
                                      $expand
                                    </v-icon>
                                  </template>
                                </v-expansion-panel-header>

                                <v-expansion-panel-content>
                                  <v-container>
                                    <v-row dense>
                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.unit.manufactureDateShow
                                          "
                                          label="Manufacture Date"
                                          color="cyan"
                                          readonly
                                        >
                                          <template v-slot:append-outer>
                                            <v-tooltip top>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  @click="
                                                    dialogManufactureUnit = true
                                                  "
                                                  :disabled="
                                                    editedItem.unit
                                                      .manufactureDate != null
                                                  "
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon
                                                    >mdi-briefcase-check</v-icon
                                                  >
                                                </v-btn>
                                              </template>
                                              <span>Mark as Manufactured</span>
                                            </v-tooltip>
                                          </template>
                                        </v-text-field>
                                      </v-col>
                                    </v-row>

                                    <v-row dense>
                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.unit.commissionDateShow
                                          "
                                          label="Commission Date"
                                          color="cyan"
                                          readonly
                                        ></v-text-field>
                                      </v-col>

                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="
                                            editedItem.unit.decommissionDateShow
                                          "
                                          label="Decommission Date"
                                          color="cyan"
                                          readonly
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="close">
                            Cancel
                          </v-btn>
                          <v-btn color="cyan" dark @click="saveUnit">
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="
                    !editedItem.unitShow &&
                      checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])
                  "
                  value="tab-2a"
                  eager
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-btn
                              block
                              outlined
                              height="100"
                              color="cyan"
                              @click="unassignedUnitDialog"
                            >
                              <v-icon left>
                                mdi-briefcase-search-outline
                              </v-icon>
                              Unassigned Unit
                            </v-btn>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-btn
                              block
                              outlined
                              color="cyan"
                              height="100"
                              @click="newUnitDialog"
                            >
                              <v-icon left>
                                mdi-briefcase-plus-outline
                              </v-icon>
                              New Unit
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="close">
                            Cancel
                          </v-btn>
                          <v-btn color="cyan" dark @click="saveUnit">
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="
                    editedItem.parts &&
                      checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])
                  "
                  value="tab-3"
                  eager
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="11">
                            <v-row>
                              <v-col
                                cols="12"
                                class="pb-0"
                                v-for="(part, index) in editedItem.parts"
                                :key="part.partID"
                              >
                                <v-card>
                                  <v-toolbar dense dark color="cyan">
                                    <v-toolbar-title>
                                      <v-btn
                                        text
                                        dark
                                        depressed
                                        @click="showPart(part.partID)"
                                      >
                                        {{
                                          part.partName
                                            ? part.partName
                                            : part.partString
                                        }}
                                      </v-btn>
                                    </v-toolbar-title>

                                    <v-spacer></v-spacer>

                                    <v-slide-x-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit != part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit != part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="deletePartDialog(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-trash-can
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Delete</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition>

                                    <v-slide-x-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit != part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit != part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="editPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-pencil
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Edit</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition>

                                    <v-slide-x-reverse-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit == part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              fab
                                              icon
                                              small
                                              @click="undoPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-undo-variant
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Undo</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-slide-x-reverse-transition>
                                      <div
                                        v-show="
                                          partShow == part.partID &&
                                            partEdit == part.partID
                                        "
                                      >
                                        <v-tooltip bottom>
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-btn
                                              v-show="
                                                partShow == part.partID &&
                                                  partEdit == part.partID
                                              "
                                              fab
                                              icon
                                              small
                                              @click="savePart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-check
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Save</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-btn
                                      fab
                                      icon
                                      small
                                      @click="showPart(part.partID)"
                                    >
                                      <v-icon v-if="partShow != part.partID"
                                        >mdi-chevron-down</v-icon
                                      >
                                      <v-icon v-else>mdi-chevron-up</v-icon>
                                    </v-btn>
                                  </v-toolbar>

                                  <v-expand-transition>
                                    <div v-show="partShow == part.partID">
                                      <v-card-text>
                                        <v-container>
                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.partName"
                                                label="Name"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.partString"
                                                label="String"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partMake"
                                                label="Make"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partModel"
                                                label="Model"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="4">
                                              <v-text-field
                                                v-model="part.partSN"
                                                label="SN"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.curveM"
                                                label="Curve M"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="6">
                                              <v-text-field
                                                v-model="part.curveB"
                                                label="Curve B"
                                                color="cyan"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12" sm="6">
                                              <v-textarea
                                                v-model="part.partNotes"
                                                rows="2"
                                                color="blue-grey"
                                                :readonly="
                                                  partEdit != part.partID
                                                "
                                                filled
                                                auto-grow
                                                background-color="orange lighten-4"
                                                dense
                                              >
                                                <template v-slot:label>
                                                  Part Notes
                                                </template>
                                              </v-textarea>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col cols="12">
                                              <v-expansion-panels>
                                                <v-expansion-panel>
                                                  <v-expansion-panel-header
                                                    color="cyan"
                                                    class="white--text"
                                                  >
                                                    Technical
                                                    <template v-slot:actions>
                                                      <v-icon color="white">
                                                        $expand
                                                      </v-icon>
                                                    </template>
                                                  </v-expansion-panel-header>

                                                  <v-expansion-panel-content>
                                                    <v-container>
                                                      <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.installDateShow
                                                            "
                                                            label="Install Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>

                                                      <v-row dense>
                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.commissionDateShow
                                                            "
                                                            label="Commission Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>

                                                        <v-col cols="12" sm="6">
                                                          <v-text-field
                                                            v-model="
                                                              part.decommissionDateShow
                                                            "
                                                            label="Decommission Date"
                                                            color="cyan"
                                                            disabled
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>
                                                    </v-container>
                                                  </v-expansion-panel-content>
                                                </v-expansion-panel>
                                              </v-expansion-panels>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                    </div>
                                  </v-expand-transition>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="1"
                            :offset="
                              Object.keys(editedItem.parts).length > 0 ? 0 : 10
                            "
                          >
                            <v-row>
                              <v-col cols="12">
                                <v-btn
                                  icon
                                  elevation="2"
                                  fab
                                  @click="addPartDialog"
                                >
                                  <v-icon>
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this LOL?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDelete">
                Cancel
              </v-btn>
              <v-btn color="error" dark @click="deleteItemConfirm">
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogNewUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Create a New Unit
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="unitCreate.unitNumber"
                      label="Unit Number"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-model="unitCreate.unitNotes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      background-color="orange lighten-4"
                    >
                      <template v-slot:label>
                        Unit Notes
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="newUnitDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="newUnit">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogUnassignedUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Select an Unassigned Unit
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="unitUpdate"
                      label="Unit"
                      :items="units"
                      item-text="unitNumber"
                      item-value="unitID"
                      color="cyan"
                      item-color="cyan"
                      return-object
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="unassignedUnitDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="unassignedUnit">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDeletePart" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this part?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="deletePartDialogClose">
                Cancel
              </v-btn>
              <v-btn color="error" dark @click="destroyPart">
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAddPart" max-width="800px">
          <v-card>
            <v-card-title class="headline">
              Add Part
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.partName"
                      label="Part Name"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.partString"
                      label="Part String"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partMake"
                      label="Make"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partModel"
                      label="Model"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partSN"
                      label="SN"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-model="partCreate.partNotes"
                      rows="2"
                      color="cyan"
                    >
                      <template v-slot:label>
                        <div>Part Notes <small>(internal)</small></div>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="addPartDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="addPart">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCalibration" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Perform Calibration

              <v-spacer></v-spacer>

              <v-btn
                icon
                v-if="calibrationStep != 'initial'"
                @click="calibrationStep = 'initial'"
              >
                <v-icon>mdi-restart</v-icon>
              </v-btn>

              <v-btn icon @click="dialogCalibration = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'initial'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'keep'"
                        >
                          <v-icon left>
                            mdi-briefcase-check-outline
                          </v-icon>
                          Keep Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'change'"
                        >
                          <v-icon left>
                            mdi-briefcase-edit-outline
                          </v-icon>
                          Change Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'keep'">
                    <v-row>
                      <v-col cols="12">
                        Are you ready to complete this calibration?<br />
                        (Assigned unit will stay the same)
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'change'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'changeUnassigned'"
                        >
                          <v-icon left>
                            mdi-briefcase-search-outline
                          </v-icon>
                          Unassigned Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'changeNew'"
                        >
                          <v-icon left>
                            mdi-briefcase-plus-outline
                          </v-icon>
                          New Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeUnassigned'">
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="unitCalibration"
                          label="Unit"
                          :items="units"
                          item-text="unitNumber"
                          item-value="unitID"
                          color="cyan"
                          item-color="cyan"
                          return-object
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeNew'">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="unitCalibration.unitNumber"
                          label="Unit Number"
                          color="cyan"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="unitCalibration.unitNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Unit Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div
                    v-show="
                      calibrationStep == 'changeUnassignedConfirm' ||
                        calibrationStep == 'changeNewConfirm'
                    "
                  >
                    <v-row>
                      <v-col cols="12">
                        Are you ready to complete this calibration?
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" v-if="editedItem.unitShow">
                        <v-row>
                          <v-col cols="12">
                            Previous Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedItem.unit.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="editedItem.unit.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="6">
                        <v-row>
                          <v-col cols="12">
                            New Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="unitCalibration.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="unitCalibration.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                v-if="calibrationStep == 'changeUnassigned'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeUnassignedConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="calibrationStep == 'changeNew'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeNewConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="
                  calibrationStep == 'keep' ||
                    calibrationStep == 'changeUnassignedConfirm' ||
                    calibrationStep == 'changeNewConfirm'
                "
                class="mb-2"
                color="cyan"
                dark
                @click="performCalibration()"
              >
                Finish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDecommissionLol" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to decommission this LOL?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDecommissionLol = false">
                Cancel
              </v-btn>
              <v-btn color="error" dark @click="decommissionLol()">
                Decommission
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogManufactureUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to mark this Unit as manufactured?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogManufactureUnit = false">
                Cancel
              </v-btn>
              <v-btn color="cyan" dark @click="manufactureUnit()">
                Manufacture
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCredentials" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Please enter your credentials
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="credentials.username"
                label="Username"
                ref="username"
                autofocus
              ></v-text-field>
              <v-text-field
                v-model="credentials.password"
                label="Password"
                :type="passwordShow ? 'text' : 'password'"
                :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="passwordShow = !passwordShow"
                @keyup.enter.native="credentialsConfirm(credentials.formField)"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialogCredentials()">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                dark
                @click="credentialsConfirm(credentials.formField)"
              >
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCalibrationSwap" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to toggle this calibration's swap status?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue-grey"
                @click="dialogCalibrationSwap = false"
              >
                Cancel
              </v-btn>
              <v-btn color="blue-grey" dark @click="toggleCalibrationSwap()">
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRecallTicket" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Recall Ticket</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveRecallTicket()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogRecallTicket = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="editedItem.lolNumber"
                      label="LOL Number"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          color="blue-grey"
                          class="white--text"
                        >
                          Customer Info
                          <template v-slot:actions>
                            <v-icon color="white">
                              $expand
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="editedItem.dealer.customerName"
                                  label="Customer"
                                  color="blue-grey"
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12">
                                <v-text-field
                                  v-model="editedItem.dealer.mainAddress"
                                  label="Address"
                                  color="blue-grey"
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="editedItem.dealer.mainCity"
                                  label="City"
                                  color="blue-grey"
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" md="3">
                                <v-text-field
                                  v-model="editedItem.dealer.mainState"
                                  label="State"
                                  color="blue-grey"
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" md="3">
                                <v-text-field
                                  v-model="editedItem.dealer.mainZip"
                                  label="Zip"
                                  color="blue-grey"
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="recallTicket.contactName"
                      label="Contact Name"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="recallTicket.contactEmail"
                      label="Contact Email"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="recallTicket.reason"
                      label="Reason"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    >
                      <!-- <template v-slot:label>
                        Reason <span class="red--text">*</span>
                      </template> -->
                    </v-textarea>
                  </v-col>
                </v-row>

                <div v-if="editedItem.calibration.calibrationFlag != null">
                  <v-row>
                    <v-col cols="12">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            color="blue-grey"
                            class="white--text"
                          >
                            Recall Ticket Parts
                            <template v-slot:actions>
                              <v-icon color="white">
                                $expand
                              </v-icon>
                            </template>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <v-container class="px-0">
                              <v-row>
                                <v-col
                                  cols="12"
                                  md="8"
                                  offset-md="2"
                                  class="px-0"
                                >
                                  <v-toolbar flat>
                                    <v-autocomplete
                                      v-model="recallTicket.addPart"
                                      label="Part Search"
                                      :items="recallTicket.partSearch"
                                      item-text="partName"
                                      item-value="partID"
                                      color="blue-grey"
                                      item-color="blue-grey"
                                      return-object
                                      hide-details
                                      solo
                                    >
                                      <template v-slot:selection="data">
                                        <template
                                          v-if="data.item.partName != null"
                                        >
                                          {{ data.item.partName }}
                                        </template>
                                        <template v-else>
                                          {{ data.item.partString }}
                                        </template>
                                      </template>

                                      <template v-slot:item="data">
                                        <template
                                          v-if="data.item.partName != null"
                                        >
                                          {{ data.item.partName }}
                                        </template>
                                        <template v-else>
                                          {{ data.item.partString }}
                                        </template>
                                      </template>
                                    </v-autocomplete>

                                    <v-btn
                                      class="ml-2"
                                      fab
                                      color="white"
                                      elevation="2"
                                      @click="addPartRecallTicket()"
                                    >
                                      <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                  </v-toolbar>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-expansion-panels
                                    :key="recallTicketPartKey"
                                  >
                                    <v-expansion-panel
                                      v-for="(part,
                                      index) in recallTicket.recallTicketPart"
                                      :key="part.calibrationRecallTicketPartID"
                                    >
                                      <v-expansion-panel-header
                                        v-if="part.partID"
                                      >
                                        <template v-if="part.partName != null">
                                          {{ part.partName }}
                                        </template>
                                        <template v-else>
                                          {{ part.partString }}
                                        </template>
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content
                                        v-if="part.partID"
                                      >
                                        <v-row>
                                          <v-col cols="12" class="px-0">
                                            <v-toolbar flat>
                                              <v-text-field
                                                v-model="part.partName"
                                                label="Part Name"
                                                class="pr-2"
                                                color="blue-grey"
                                                readonly
                                                dense
                                                hide-details
                                              ></v-text-field>

                                              <v-text-field
                                                v-model="part.partString"
                                                label="Part String"
                                                class="px-2"
                                                color="blue-grey"
                                                readonly
                                                dense
                                                hide-details
                                              ></v-text-field>

                                              <v-btn
                                                class="ml-2"
                                                fab
                                                small
                                                color="white"
                                                elevation="2"
                                                @click="
                                                  removePartRecallTicket(index)
                                                "
                                              >
                                                <v-icon color="error">
                                                  mdi-trash-can-outline
                                                </v-icon>
                                              </v-btn>
                                            </v-toolbar>
                                          </v-col>
                                        </v-row>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="recallTicket.recallTicketNotes"
                        label="Notes"
                        rows="2"
                        color="blue-grey"
                        filled
                        auto-grow
                        hide-details
                        background-color="orange lighten-4"
                      ></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row>
                    <!-- History -->
                  </v-row>

                  <v-row :key="requestByKey">
                    <v-col cols="12" md="6">
                      <v-btn
                        v-if="recallTicket.requestBy == null"
                        dark
                        color="blue-grey"
                        @click="openDialogCredentials('recallTicket.requestBy')"
                      >
                        <v-icon left>mdi-account-plus</v-icon>
                        Add Request By
                      </v-btn>

                      <v-text-field
                        v-if="recallTicket.requestBy != null"
                        v-model="recallTicket.requestBy"
                        label="Request By"
                        color="blue-grey"
                        readonly
                        hide-details
                      >
                        <template v-slot:append-outer>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                @click="
                                  clearCredentials('recallTicket.requestBy')
                                "
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Clear Request By</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-if="recallTicket.requestBy != null"
                        v-model="recallTicket.requestDateShow"
                        label="Request Date"
                        color="blue-grey"
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row :key="authorizedByKey">
                    <v-col cols="12" md="6">
                      <v-btn
                        v-if="recallTicket.authorizedBy == null"
                        dark
                        color="blue-grey"
                        @click="
                          openDialogCredentials('recallTicket.authorizedBy')
                        "
                      >
                        <v-icon left>mdi-account-plus</v-icon>
                        Add Authorized By
                      </v-btn>

                      <v-text-field
                        v-if="recallTicket.authorizedBy != null"
                        v-model="recallTicket.authorizedBy"
                        label="Authorized By"
                        color="blue-grey"
                        readonly
                        hide-details
                      >
                        <template v-slot:append-outer>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                @click="
                                  clearCredentials('recallTicket.authorizedBy')
                                "
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <span>Clear Authorized By</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-if="recallTicket.authorizedBy != null"
                        v-model="recallTicket.authorizedDateShow"
                        label="Authorized Date"
                        color="blue-grey"
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="editedItem.calibration.recallTicketDate == null"
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('recallTicket')"
              >
                Mark Complete
              </v-btn>

              <v-list v-else class="mb-2 pa-0" dense>
                <v-list-item class="pa-0" two-line>
                  <v-list-item-avatar class="my-0">
                    <v-icon class="success" dark>
                      mdi-check
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Complete Date</v-list-item-title>
                    <v-list-item-subtitle>{{
                      editedItem.calibration.recallTicketDateShow
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogSchedule" max-width="800px">
          <v-card>
            <v-card-title>
              Schedule Calibration
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogSchedule = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-sheet height="64">
                <v-toolbar flat>
                  <v-btn
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="$refs.calendar.prev()"
                  >
                    <v-icon small>
                      mdi-chevron-left
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="mr-4"
                    fab
                    text
                    small
                    color="grey darken-2"
                    @click="$refs.calendar.next()"
                  >
                    <v-icon small>
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">
                    {{ $refs.calendar.title }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="d-none d-sm-flex"
                    depressed
                    dark
                    color="blue-grey"
                    @click="confirmAutoSchedule()"
                  >
                    <v-icon left>
                      mdi-calendar-search
                    </v-icon>
                    Auto-Schedule
                  </v-btn>
                  <v-btn
                    class="d-sm-none"
                    fab
                    dark
                    small
                    color="blue-grey"
                    @click="confirmAutoSchedule()"
                  >
                    <v-icon>
                      mdi-calendar-search
                    </v-icon>
                  </v-btn>
                </v-toolbar>
              </v-sheet>
              <v-sheet height="600">
                <v-calendar
                  ref="calendar"
                  v-model="calendarSchedule"
                  weekdays="1,2,3,4,5"
                  :events="calendarEvents"
                  @change="getCalendarEvents()"
                  @click:date="confirmSchedule"
                  :start="calendarStart"
                  :show-month-on-first="false"
                ></v-calendar>
              </v-sheet>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmSchedule" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to schedule the calibration for
              {{ schedule.calibrationScheduleDateShow }}?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue-grey"
                @click="dialogConfirmSchedule = false"
              >
                Cancel
              </v-btn>
              <v-btn color="blue-grey" dark @click="scheduleDetails()">
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogScheduleDetails" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Confirmation
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <span class="text-subtitle-2">Email Notice</span><br />
                  An email notice will be automatically sent to the contact
                  email specified in the Recall Ticket.
                </v-col>
                <v-col cols="12">
                  <span class="text-subtitle-2">Phone Notice</span>
                  <v-textarea
                    v-model="schedule.schedulePhoneNotes"
                    label="Phone Notes"
                    rows="2"
                    color="blue-grey"
                    filled
                    auto-grow
                    background-color="orange lighten-4"
                    hint="Enter any notes from the required phone call confirmation"
                    persistent-hint
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="blue-grey"
                @click="dialogScheduleDetails = false"
              >
                Cancel
              </v-btn>
              <v-btn color="blue-grey" dark @click="scheduleDay()">
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogReceiving" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Receiving</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveReceiving()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogReceiving = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row :key="receivedByKey">
                  <v-col cols="12" md="6">
                    <v-btn
                      v-if="receiving.receivedBy == null"
                      dark
                      color="blue-grey"
                      @click="openDialogCredentials('receiving.receivedBy')"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Add Received By
                    </v-btn>

                    <v-text-field
                      v-else
                      v-model="receiving.receivedBy"
                      label="Received By"
                      color="blue-grey"
                      readonly
                      hide-details
                    >
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="clearCredentials('receiving.receivedBy')"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Received By</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-if="receiving.receivedBy != null"
                      v-model="receiving.receiveDateShow"
                      label="Receive Date"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          color="blue-grey"
                          class="white--text"
                        >
                          Receiving Items
                          <template v-slot:actions>
                            <v-icon color="white">
                              $expand
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-container class="px-0">
                            <v-row>
                              <v-col cols="12" class="px-0">
                                <v-toolbar flat>
                                  <v-row>
                                    <v-col cols="8" md="9">
                                      <v-combobox
                                        v-model="receiving.addItem.description"
                                        label="Item Search"
                                        :items="receiving.itemSearch"
                                        color="blue-grey"
                                        item-color="blue-grey"
                                        hide-details
                                        solo
                                      ></v-combobox>
                                    </v-col>

                                    <v-col cols="4" md="3">
                                      <v-text-field
                                        v-model="receiving.addItem.quantity"
                                        label="Quantity"
                                        color="blue-grey"
                                        type="number"
                                        hide-details
                                        solo
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-btn
                                    class="ml-2"
                                    fab
                                    color="white"
                                    elevation="2"
                                    @click="addItemReceiving()"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-toolbar>
                              </v-col>
                            </v-row>

                            <v-row :key="receivingItemKey">
                              <v-col
                                cols="12"
                                class="px-0"
                                v-for="(item, index) in receiving.receivingItem"
                                :key="item.calibrationReceivingItemID"
                              >
                                <v-toolbar flat>
                                  <v-row>
                                    <v-col cols="8" md="9">
                                      <v-text-field
                                        v-model="item.description"
                                        label="Description"
                                        class="pr-2"
                                        color="blue-grey"
                                        readonly
                                        dense
                                        hide-details
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="4" md="3">
                                      <v-text-field
                                        v-model="item.quantity"
                                        label="Quantity"
                                        class="px-2"
                                        color="blue-grey"
                                        readonly
                                        dense
                                        hide-details
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-btn
                                    class="ml-2"
                                    fab
                                    small
                                    text
                                    depressed
                                    color="error"
                                    @click="removeItemReceiving(index)"
                                  >
                                    <v-icon>
                                      mdi-close
                                    </v-icon>
                                  </v-btn>
                                </v-toolbar>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="receiving.receiveNotes"
                      label="Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="receiving.dhNotes"
                      label="Department Head Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('receiving')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogOrder" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Order</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveOrder()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogOrder = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="order.orderNumber"
                      label="Order Number"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row :key="orderedByKey">
                  <v-col cols="12" md="6">
                    <v-btn
                      v-if="order.orderedBy == null"
                      dark
                      color="blue-grey"
                      @click="openDialogCredentials('order.orderedBy')"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Add Order By
                    </v-btn>

                    <v-text-field
                      v-if="order.orderedBy != null"
                      v-model="order.orderedBy"
                      label="Order By"
                      color="blue-grey"
                      readonly
                      hide-details
                    >
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="clearCredentials('order.orderedBy')"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Order By</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-if="order.orderedBy != null"
                      v-model="order.orderDateShow"
                      label="Order Date"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('order')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogInventoryIn" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Inventory In</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveInventoryIn()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogInventoryIn = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="inventoryIn.unitIn"
                      color="blue-grey"
                      label="LOL Unit"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="inventoryIn.unitInCondition"
                      label="LOL Unit Condition"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="inventoryIn.tabletIn"
                      color="blue-grey"
                      label="Tablet"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="inventoryIn.tabletInCondition"
                      label="Tablet Condition"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="inventoryIn.inventoryInNotes"
                      label="Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('inventoryIn')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogServiceTicket" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Service Ticket</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="openRecallTicketDialog(editedItem)"
                    >
                      <v-icon>mdi-ticket-percent-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>View Recall Ticket</span>
                </v-tooltip>

                <v-btn icon :loading="saving.show" @click="saveServiceTicket()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogServiceTicket = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- <v-row>
                  <v-col cols="6">
                    
                  </v-col>

                  <v-col cols="6">
                    
                  </v-col>
                </v-row> -->

                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          color="blue-grey"
                          class="white--text"
                        >
                          Service Ticket Parts
                          <template v-slot:actions>
                            <v-icon color="white">
                              $expand
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-container>
                            <v-row>
                              <v-col cols="12" md="8" offset-md="2">
                                <v-toolbar flat>
                                  <v-autocomplete
                                    v-model="serviceTicket.addPart"
                                    label="Part Search"
                                    :items="serviceTicket.partSearch"
                                    item-text="partName"
                                    item-value="partID"
                                    color="blue-grey"
                                    item-color="blue-grey"
                                    return-object
                                    hide-details
                                    solo
                                  >
                                    <template v-slot:selection="data">
                                      <template
                                        v-if="data.item.partName != null"
                                      >
                                        {{ data.item.partName }}
                                      </template>
                                      <template v-else>
                                        {{ data.item.partString }}
                                      </template>
                                    </template>

                                    <template v-slot:item="data">
                                      <template
                                        v-if="data.item.partName != null"
                                      >
                                        {{ data.item.partName }}
                                      </template>
                                      <template v-else>
                                        {{ data.item.partString }}
                                      </template>
                                    </template>
                                  </v-autocomplete>

                                  <v-btn
                                    class="ml-2"
                                    fab
                                    color="white"
                                    elevation="2"
                                    @click="addPartServiceTicket()"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-toolbar>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12">
                                <v-expansion-panels :key="serviceTicketPartKey">
                                  <v-expansion-panel
                                    v-for="(part,
                                    index) in serviceTicket.serviceTicketPart"
                                    :key="part.calibrationServiceTicketPartID"
                                  >
                                    <v-expansion-panel-header
                                      v-if="part.partID"
                                    >
                                      <template v-if="part.partName != null">
                                        {{ part.partName }}
                                      </template>
                                      <template v-else>
                                        {{ part.partString }}
                                      </template>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content
                                      v-if="part.partID"
                                    >
                                      <v-row>
                                        <v-col cols="12">
                                          <v-toolbar flat>
                                            <v-text-field
                                              v-model="part.partName"
                                              label="Part Name"
                                              class="pr-2"
                                              color="blue-grey"
                                              readonly
                                              dense
                                              hide-details
                                            ></v-text-field>

                                            <v-text-field
                                              v-model="part.partString"
                                              label="Part String"
                                              class="px-2"
                                              color="blue-grey"
                                              readonly
                                              dense
                                              hide-details
                                            ></v-text-field>

                                            <v-btn
                                              class="ml-2"
                                              fab
                                              small
                                              color="white"
                                              elevation="2"
                                              @click="
                                                removePartServiceTicket(index)
                                              "
                                            >
                                              <v-icon color="error">
                                                mdi-trash-can-outline
                                              </v-icon>
                                            </v-btn>
                                          </v-toolbar>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-expansion-panels>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="serviceTicket.serviceTicketNotes"
                      label="Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row :key="serviceByKey">
                  <v-col cols="12" md="6">
                    <v-btn
                      v-if="serviceTicket.serviceBy == null"
                      dark
                      color="blue-grey"
                      @click="openDialogCredentials('serviceTicket.serviceBy')"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Add Service By
                    </v-btn>

                    <v-text-field
                      v-if="serviceTicket.serviceBy != null"
                      v-model="serviceTicket.serviceBy"
                      label="Service By"
                      color="blue-grey"
                      readonly
                      hide-details
                    >
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="
                                clearCredentials('serviceTicket.serviceBy')
                              "
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Service By</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-if="serviceTicket.serviceBy != null"
                      v-model="serviceTicket.serviceDateShow"
                      label="Service Date"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <div class="my-6">
                  <v-divider></v-divider>
                </div>

                <v-row>
                  <v-col cols="12">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header
                          color="blue-grey"
                          class="white--text"
                        >
                          Service Ticket Materials
                          <template v-slot:actions>
                            <v-icon color="white">
                              $expand
                            </v-icon>
                          </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <v-container class="px-0">
                            <v-row>
                              <v-col cols="12" class="px-0">
                                <v-toolbar flat>
                                  <v-row>
                                    <v-col cols="4" md="5">
                                      <!-- <v-combobox
                                        v-model="serviceTicket.addMaterial.partNumber"
                                        label="Part Number"
                                        :items="serviceTicket.materialSearch"
                                        color="blue-grey"
                                        item-color="blue-grey"
                                        hide-details
                                        solo
                                      ></v-combobox> -->

                                      <v-text-field
                                        v-model="
                                          serviceTicket.addMaterial.partNumber
                                        "
                                        label="Part Number"
                                        color="blue-grey"
                                        hide-details
                                        solo
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="4" md="4">
                                      <v-text-field
                                        v-model="
                                          serviceTicket.addMaterial.description
                                        "
                                        label="Description"
                                        color="blue-grey"
                                        hide-details
                                        solo
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="4" md="3">
                                      <v-text-field
                                        v-model="
                                          serviceTicket.addMaterial.quantity
                                        "
                                        label="Quantity"
                                        color="blue-grey"
                                        type="number"
                                        hide-details
                                        solo
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-btn
                                    class="ml-2"
                                    fab
                                    color="white"
                                    elevation="2"
                                    @click="addMaterialServiceTicket()"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </v-toolbar>
                              </v-col>
                            </v-row>

                            <v-row :key="serviceTicketMaterialKey">
                              <v-col
                                cols="12"
                                class="px-0"
                                v-for="(item,
                                index) in serviceTicket.serviceTicketMaterial"
                                :key="item.calibrationServiceTicketMaterialID"
                              >
                                <v-toolbar flat>
                                  <v-row>
                                    <v-col cols="4" md="5">
                                      <v-text-field
                                        v-model="item.partNumber"
                                        label="Part Number"
                                        class="pr-2"
                                        color="blue-grey"
                                        readonly
                                        dense
                                        hide-details
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="4" md="4">
                                      <v-text-field
                                        v-model="item.description"
                                        label="Description"
                                        class="pr-2"
                                        color="blue-grey"
                                        readonly
                                        dense
                                        hide-details
                                      ></v-text-field>
                                    </v-col>

                                    <v-col cols="4" md="3">
                                      <v-text-field
                                        v-model="item.quantity"
                                        label="Quantity"
                                        class="px-2"
                                        color="blue-grey"
                                        readonly
                                        dense
                                        hide-details
                                      ></v-text-field>
                                    </v-col>
                                  </v-row>

                                  <v-btn
                                    class="ml-2"
                                    fab
                                    small
                                    text
                                    depressed
                                    color="error"
                                    @click="removeMaterialServiceTicket(index)"
                                  >
                                    <v-icon>
                                      mdi-close
                                    </v-icon>
                                  </v-btn>
                                </v-toolbar>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="serviceTicket.laborHours"
                      label="Labor Hours"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row :key="laborByKey">
                  <v-col cols="12" md="6">
                    <v-btn
                      v-if="serviceTicket.laborBy == null"
                      dark
                      color="blue-grey"
                      @click="openDialogCredentials('serviceTicket.laborBy')"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Add Labor By
                    </v-btn>

                    <v-text-field
                      v-if="serviceTicket.laborBy != null"
                      v-model="serviceTicket.laborBy"
                      label="Labor By"
                      color="blue-grey"
                      readonly
                      hide-details
                    >
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="clearCredentials('serviceTicket.laborBy')"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Labor By</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-if="serviceTicket.laborBy != null"
                      v-model="serviceTicket.laborDateShow"
                      label="Labor Date"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('serviceTicket')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogCalibrationTicket"
          max-width="800px"
          scrollable
        >
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Calibration Ticket</v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn
                  icon
                  :loading="saving.show"
                  @click="saveReceiving()"
                >
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn> -->

                <v-btn icon @click="dialogCalibrationTicket = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text
              v-cloak
              @drop.prevent="addDropFileCalibrationTicket"
              @dragover.prevent
            >
              <v-container>
                <v-card @click="addClickFileCalibrationTicket()" flat>
                  <v-card-text>
                    <v-row
                      class="d-flex flex-column"
                      dense
                      align="center"
                      justify="center"
                    >
                      <v-icon class="mt-5" size="60">
                        mdi-cloud-upload
                      </v-icon>

                      <p>Drop your file here, or click to select one.</p>

                      <v-col cols="12" md="6">
                        <v-file-input
                          ref="calibrationTicketFileInput"
                          v-model="calibrationTicket.file"
                          label="Select a file"
                          chips
                          show-size
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('calibrationTicket')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogChecklist" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Checklist</v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn
                  icon
                  :loading="saving.show"
                  @click="saveReceiving()"
                >
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn> -->

                <v-btn icon @click="dialogChecklist = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text
              v-cloak
              @drop.prevent="addDropFileChecklist"
              @dragover.prevent
            >
              <v-container>
                <v-card @click="addClickFileChecklist()" flat>
                  <v-card-text>
                    <v-row
                      class="d-flex flex-column"
                      dense
                      align="center"
                      justify="center"
                    >
                      <v-icon class="mt-5" size="60">
                        mdi-cloud-upload
                      </v-icon>

                      <p>Drop your file here, or click to select one.</p>

                      <v-col cols="12" md="6">
                        <v-file-input
                          ref="checklistFileInput"
                          v-model="checklist.file"
                          label="Select a file"
                          chips
                          show-size
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('checklist')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogInventoryOut" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Inventory Out</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveInventoryOut()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogInventoryOut = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="inventoryOut.unitOut"
                      color="blue-grey"
                      label="LOL Unit"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="inventoryOut.unitOutCondition"
                      label="LOL Unit Condition"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="inventoryOut.tabletOut"
                      color="blue-grey"
                      label="Tablet"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="inventoryOut.tabletOutCondition"
                      label="Tablet Condition"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="inventoryOut.inventoryOutNotes"
                      label="Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      hide-details
                      background-color="orange lighten-4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('inventoryOut')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogFulfill" max-width="800px" scrollable>
          <v-card>
            <v-card-title class="pa-0" style="word-break: normal">
              <v-toolbar dark color="blue-grey">
                <v-toolbar-title>Fulfill</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon :loading="saving.show" @click="saveFulfill()">
                  <v-icon>{{ saving.icon }}</v-icon>
                </v-btn>

                <v-btn icon @click="dialogFulfill = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fulfill.shipVia"
                      label="Ship Via"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="fulfill.trackingNumber"
                      label="Tracking Number"
                      color="blue-grey"
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="fulfill.fulfillPhoneNotes"
                      label="Phone Notes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      background-color="orange lighten-4"
                      hint="Enter any notes from the required phone call confirmation"
                      persistent-hint
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row :key="fulfilledByKey">
                  <v-col cols="12" md="6">
                    <v-btn
                      v-if="fulfill.fulfilledBy == null"
                      dark
                      color="blue-grey"
                      @click="openDialogCredentials('fulfill.fulfilledBy')"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      Add Fulfill By
                    </v-btn>

                    <v-text-field
                      v-if="fulfill.fulfilledBy != null"
                      v-model="fulfill.fulfilledBy"
                      label="Fulfill By"
                      color="blue-grey"
                      readonly
                      hide-details
                    >
                      <template v-slot:append-outer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              @click="clearCredentials('fulfill.fulfilledBy')"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Clear Fulfill By</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-if="fulfill.fulfilledBy != null"
                      v-model="fulfill.fulfillDateShow"
                      label="Fulfill Date"
                      color="blue-grey"
                      readonly
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                color="blue-grey"
                dark
                @click="openDialogMarkComplete('fulfill')"
              >
                Mark Complete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogMarkComplete" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to mark this step complete?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="blue-grey" @click="dialogMarkComplete = false">
                Cancel
              </v-btn>
              <v-btn color="blue-grey" dark @click="markComplete()">
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.lolNumber="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.lolNumber }}
          </span>
        </template>
        <span>View LOL</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            :color="props.item.calibrationSwap ? 'amber' : 'grey darken-1'"
            v-bind="attrs"
            v-on="on"
            @click="openDialogCalibrationSwap(props.item)"
          >
            <v-icon>
              mdi-swap-horizontal-bold
            </v-icon>
          </v-btn>
        </template>
        <span>Toggle Calibration Swap</span>
      </v-tooltip>

      <v-tooltip top v-if="props.item.calibrationFlag != null">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="error" v-bind="attrs" v-on="on">
            mdi-alert-circle
          </v-icon>
        </template>
        <span>Flagged for Calibration</span>
      </v-tooltip>
    </template>

    <template v-slot:item.nextStep="props">
      <v-btn
        v-if="props.item.nextStep == 'recallTicket'"
        plain
        @click="openRecallTicketDialog(props.item)"
      >
        <v-icon left>mdi-ticket-percent-outline</v-icon>
        <span>Recall Ticket</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'schedule'"
        plain
        @click="openScheduleDialog(props.item)"
      >
        <v-icon left>mdi-calendar</v-icon>
        <span>Schedule</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'receiving'"
        plain
        @click="openReceivingDialog(props.item)"
      >
        <v-icon left>mdi-package-variant</v-icon>
        <span>Receiving</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'order'"
        plain
        @click="openOrderDialog(props.item)"
      >
        <v-icon left>mdi-face-agent</v-icon>
        <span>Order</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'inventoryIn'"
        plain
        @click="openInventoryInDialog(props.item)"
      >
        <v-icon left>mdi-archive-arrow-down-outline</v-icon>
        <span>Inventory In</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'serviceTicket'"
        plain
        @click="openServiceTicketDialog(props.item)"
      >
        <v-icon left>mdi-file-cog-outline</v-icon>
        <span>Service Ticket</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'calibrationTicket'"
        plain
        @click="openCalibrationTicketDialog(props.item)"
      >
        <v-icon left>mdi-file-document-edit-outline</v-icon>
        <span>Calibration Ticket</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'checklist'"
        plain
        @click="openChecklistDialog(props.item)"
      >
        <v-icon left>mdi-file-check-outline</v-icon>
        <span>Checklist</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'inventoryOut'"
        plain
        @click="openInventoryOutDialog(props.item)"
      >
        <v-icon left>mdi-archive-arrow-up-outline</v-icon>
        <span>Inventory Out</span>
      </v-btn>

      <v-btn
        v-if="props.item.nextStep == 'fulfill'"
        plain
        @click="openFulfillDialog(props.item)"
      >
        <v-icon left>mdi-truck</v-icon>
        <span>Fulfill</span>
      </v-btn>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>

        <v-list>
          <v-list-item @click="openRecallTicketDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-ticket-percent-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Recall Ticket</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openScheduleDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-calendar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Schedule</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openReceivingDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-package-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Receiving</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openOrderDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-face-agent</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Order</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openInventoryInDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-archive-arrow-down-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Inventory In</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openServiceTicketDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-file-cog-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Service Ticket</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openCalibrationTicketDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-file-document-edit-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Calibration Ticket</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openChecklistDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-file-check-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Checklist</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openInventoryOutDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-archive-arrow-up-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Inventory Out</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="openFulfillDialog(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-truck</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Fulfill</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <template v-slot:expanded-item="{ item }">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            Test
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import LolService from '../../../services/lol.service'
import UnitService from '../../../services/unit.service'
import PartService from '../../../services/part.service'
import CurveService from '../../../services/curve.service'
import CustomerService from '../../../services/customer.service'
import LocationService from '../../../services/location.service'
import AuthService from '../../../services/auth.service'
import CalibrationService from '../../../services/calibration.service'
import CalibrationInventoryInService from '../../../services/calibrationInventoryIn.service'
import CalibrationInventoryOutService from '../../../services/calibrationInventoryOut.service'
import CalibrationOrderService from '../../../services/calibrationOrder.service'
import CalibrationRecallTicketService from '../../../services/calibrationRecallTicket.service'
import CalibrationRecallTicketPartService from '../../../services/calibrationRecallTicketPart.service'
import CalibrationReceivingService from '../../../services/calibrationReceiving.service'
import CalibrationReceivingItemService from '../../../services/calibrationReceivingItem.service'
import CalibrationServiceTicketService from '../../../services/calibrationServiceTicket.service'
import CalibrationServiceTicketMaterialService from '../../../services/calibrationServiceTicketMaterial.service'
import CalibrationServiceTicketPartService from '../../../services/calibrationServiceTicketPart.service'
import UploadService from '../../../services/upload.service'

export default {
  data: () => ({
    search: '',
    message: '',
    selected: [],
    loading: false,
    scheduleSheet: false,
    calibrationSheet: false,
    lolSheet: false,
    calibrationTab: null,
    tab: null,
    dialogDelete: false,
    dialogNewUnit: false,
    dialogUnassignedUnit: false,
    dialogAddPart: false,
    dialogDeletePart: false,
    dialogCalibration: false,
    dialogDecommissionLol: false,
    dialogManufactureUnit: false,
    dialogCredentials: false,
    dialogCalibrationSwap: false,
    dialogRecallTicket: false,
    dialogSchedule: false,
    dialogConfirmSchedule: false,
    dialogConfirmAutoSchedule: false,
    dialogScheduleDetails: false,
    dialogReceiving: false,
    dialogOrder: false,
    dialogInventoryIn: false,
    dialogServiceTicket: false,
    dialogCalibrationTicket: false,
    dialogChecklist: false,
    dialogInventoryOut: false,
    dialogFulfill: false,
    dialogMarkComplete: false,
    markCompleteStep: null,
    calendarSchedule: null,
    calendarEvents: [],
    calendarStart: null,
    calendarEnd: null,
    scheduleType: null,
    schedule: {
      calibrationScheduleDate: null,
      schedulePhoneNotes: null
    },
    headers: [
      { text: 'LOL Number', align: 'start', value: 'lolNumber' },
      { text: 'Next Calibration Date', value: 'calibrationDateShow' },
      { text: 'Dealer', value: 'dealer.customerName' },
      { text: 'Location', value: 'location.locationName' },
      { text: 'Next Step', align: 'center', value: 'nextStep' },
      { text: 'Actions', value: 'actions', align: 'center', sortable: false }
    ],
    lols: [],
    dealers: [],
    locations: [],
    units: [],
    calibrations: [],
    unitAddStep: '',
    partShow: 0,
    partEdit: 0,
    unitCreate: {},
    unitUpdate: {},
    unitCalibration: {},
    calibrationData: {},
    calibrationStep: 'initial',
    partCreate: {},
    partBeforeEdit: {},
    partUpdate: {},
    partDelete: null,
    editedIndex: -1,
    editedItem: {
      lolNumber: '',
      lolName: null,
      lolNotes: null,
      debugMode: null,
      customerID: null,
      locationID: null,
      dealer: {
        customerName: null,
        mainAddress: null,
        mainCity: null,
        mainState: null,
        mainZip: null
      },
      calibrationFlag: null,
      calibration: {
        calibrationID: null,
        calibrationFlag: null
      }
    },
    defaultItem: {
      lolNumber: '',
      calibrationFlag: null,
      calibration: {
        calibrationID: null,
        calibrationFlag: null
      }
    },
    recallTicket: {
      calibrationID: null,
      contactName: null,
      contactEmail: null,
      reason: null,
      recallTicketNotes: null,
      requestedByID: null,
      requestDate: null,
      authorizedByID: null,
      authorizeDate: null,
      partSearch: [],
      addPart: null,
      recallTicketPart: [
        {
          partID: null,
          partName: null,
          partString: null
        }
      ],
      recallTicketPartBefore: [
        {
          partID: null,
          partName: null,
          partString: null
        }
      ]
    },
    receiving: {
      calibrationID: null,
      receivedByID: null,
      receiveDate: null,
      receiveNotes: null,
      dhNotes: null,
      addItem: {
        description: null,
        quantity: null
      },
      receivingItem: [
        {
          calibrationReceivingItemID: null,
          description: null,
          quantity: null
        }
      ],
      receivingItemBefore: [
        {
          calibrationReceivingItemID: null,
          description: null,
          quantity: null
        }
      ]
    },
    order: {
      orderNumber: null,
      orderedByID: null,
      orderDate: null
    },
    inventoryIn: {
      unitIn: null,
      unitInCondition: null,
      tabletIn: null,
      tabletInCondition: null,
      inventoryInNotes: null
    },
    serviceTicket: {
      calibrationID: null,
      // recallTicketID: null,
      receiveDate: null,
      beforeUnitID: null,
      afterUnitID: null,
      serviceByID: null,
      serviceDate: null,
      serviceTicketNotes: null,
      laborByID: null,
      laborDate: null,
      laborHours: null,
      partSearch: [],
      addPart: null,
      serviceTicketPart: [
        {
          partID: null,
          partName: null,
          partString: null
        }
      ],
      serviceTicketPartBefore: [
        {
          partID: null,
          partName: null,
          partString: null
        }
      ],
      addMaterial: {
        partNumber: null,
        description: null,
        quantity: null
      },
      serviceTicketMaterial: [
        {
          calibrationServiceTicketMaterialID: null,
          partNumber: null,
          description: null,
          quantity: null
        }
      ],
      serviceTicketMaterialBefore: [
        {
          calibrationServiceTicketMaterialID: null,
          partNumber: null,
          description: null,
          quantity: null
        }
      ]
    },
    calibrationTicket: {
      calibrationID: null,
      file: null
    },
    checklist: {
      calibrationID: null,
      file: null
    },
    inventoryOut: {
      unitOut: null,
      unitOutCondition: null,
      tabletOut: null,
      tabletOutCondition: null,
      inventoryOutNotes: null
    },
    fulfill: {
      shipVia: null,
      trackingNumber: null,
      fulfillPhoneDate: null,
      fulfillPhoneNotes: null,
      fulfilledByID: null,
      fulfillDate: null
    },
    credentials: {
      username: null,
      password: ''
    },
    passwordShow: false,
    saving: {
      show: false,
      icon: 'mdi-content-save-outline'
    },
    editMode: false,
    editModeDealer: false,
    rules: {
      required: [(value) => value.length != 0 || 'Required']
    },
    recallTicketPartKey: 0,
    requestByKey: 100,
    authorizedByKey: 200,
    receivingItemKey: 300,
    receivedByKey: 400,
    orderedByKey: 500,
    serviceTicketPartKey: 600,
    serviceByKey: 700,
    serviceTicketMaterialKey: 800,
    laborByKey: 900,
    fulfilledByKey: 1000
  }),

  computed: {
    currentUser() {
      return this.$store.state.auth.user
    }
  },

  watch: {},

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.checkAuth()
      this.retrieveCalibrations()
      // this.retrieveLols()
      // this.retrieveDealers()
      // this.retrieveLocations()
      // this.retrieveUnassignedUnits()
    },

    checkAuth() {
      if (
        !this.$route.meta.authorize.includes(this.currentUser.roles.toString())
      ) {
        this.$router.push('/dashboard')
      }
    },

    checkRole(role) {
      if (Array.isArray(role)) {
        var i
        for (i = 0; i < role.length; i++) {
          if (this.currentUser.roles.includes(role[i])) {
            return true
          }
          if (role[i] == 'lf') {
            if (
              this.currentUser.roles.includes('ROLE_LFADMIN') ||
              this.currentUser.roles.includes('ROLE_LFTECH') ||
              this.currentUser.roles.includes('ROLE_LFBILLING')
            ) {
              return true
            }
          }
          if (role[i] == 'dealer') {
            if (
              this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
              this.currentUser.roles.includes('ROLE_DEALERTECH')
            ) {
              return true
            }
          }
        }
        return false
      }

      if (role == 'lf') {
        if (
          this.currentUser.roles.includes('ROLE_LFADMIN') ||
          this.currentUser.roles.includes('ROLE_LFTECH') ||
          this.currentUser.roles.includes('ROLE_LFBILLING')
        ) {
          return true
        }
      }

      if (role == 'dealer') {
        if (
          this.currentUser.roles.includes('ROLE_DEALERADMIN') ||
          this.currentUser.roles.includes('ROLE_DEALERTECH')
        ) {
          return true
        }
      }

      if (this.currentUser.roles.includes(role)) {
        return true
      } else {
        return false
      }
    },

    async retrieveCalibrations() {
      this.loading = true
      await LolService.getAll().then(async (response) => {
        this.lols = response.data || []

        var index = 0
        var showCalibrationDate = new Date()
        showCalibrationDate.setDate(1)
        showCalibrationDate.setMonth(showCalibrationDate.getMonth() + 2)
        var indexRemoval = []
        for (const lol of this.lols) {
          CustomerService.get(lol.customerID)
            .then((response) => {
              lol.dealer = response.data
            })
            .catch((err) => {
              console.log(err)
            })
          LocationService.get(lol.locationID)
            .then((response) => {
              lol.location = response.data
            })
            .catch((err) => {
              console.log(err)
            })

          await UnitService.getLolUnits(lol.lolID)
            .then(async (response) => {
              lol.unit = response.data[0] || {}

              await PartService.getUnitParts(lol.unit.unitID).then(
                async (response) => {
                  if (response.data.length) {
                    lol.unit.parts = response.data
                  } else {
                    lol.unit.parts = [{ partID: null }]
                  }

                  return new Promise((resolve) => {
                    resolve('Done')
                  })
                }
              )

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((err) => {
              console.log(err)

              return new Promise((resolve) => {
                resolve('Done')
              })
            })

          await CalibrationService.getLolCalibrationsFull(lol.lolID)
            .then(async (response) => {
              if (response.data.length) {
                lol.calibration = response.data[0]
                lol.calibrationFlag = response.data[0].calibrationFlag
                lol.calibrationSwap = response.data[0].calibrationSwap

                if (!lol.calibration.calibrationSwap) {
                  if (lol.calibration.recallTicketDate == null) {
                    lol.nextStep = 'recallTicket'
                  } else if (lol.calibration.scheduleDate == null) {
                    lol.nextStep = 'schedule'
                  } else if (lol.calibration.receiveDate == null) {
                    lol.nextStep = 'receiving'
                  } else if (lol.calibration.orderDate == null) {
                    lol.nextStep = 'order'
                  } else if (lol.calibration.inventoryInDate == null) {
                    lol.nextStep = 'inventoryIn'
                  } else if (lol.calibration.serviceTicketDate == null) {
                    lol.nextStep = 'serviceTicket'
                  } else if (lol.calibration.calibrationTicketDate == null) {
                    lol.nextStep = 'calibrationTicket'
                  } else if (lol.calibration.checklistDate == null) {
                    lol.nextStep = 'checklist'
                  } else if (lol.calibration.inventoryOutDate == null) {
                    lol.nextStep = 'inventoryOut'
                  } else if (lol.calibration.fulfillDate == null) {
                    lol.nextStep = 'fulfill'
                  }
                } else {
                  if (lol.calibration.recallTicketDate == null) {
                    lol.nextStep = 'recallTicket'
                  } else if (lol.calibration.scheduleDate == null) {
                    lol.nextStep = 'schedule'
                  } else if (lol.calibration.orderDate == null) {
                    lol.nextStep = 'order'
                  } else if (lol.calibration.fulfillDate == null) {
                    lol.nextStep = 'fulfill'
                  } else if (lol.calibration.inventoryInDate == null) {
                    lol.nextStep = 'inventoryIn'
                  } else if (lol.calibration.serviceTicketDate == null) {
                    lol.nextStep = 'serviceTicket'
                  } else if (lol.calibration.calibrationTicketDate == null) {
                    lol.nextStep = 'calibrationTicket'
                  } else if (lol.calibration.checklistDate == null) {
                    lol.nextStep = 'checklist'
                  } else if (lol.calibration.inventoryOutDate == null) {
                    lol.nextStep = 'inventoryOut'
                  } else if (lol.calibration.receiveDate == null) {
                    lol.nextStep = 'receiving'
                  }
                }
              } else {
                lol.calibration = {
                  calibrationID: null,
                  calibrationFlag: null
                }
                lol.calibrationFlag = null
                lol.calibrationSwap = null
                lol.nextStep = 'recallTicket'
              }
              var calibrations = response.data || []

              if (calibrations.length) {
                lol.calibration = response.data[0]
                if (calibrations[0].completeDate) {
                  lol.calibrationDate = new Date(calibrations[0].completeDate)
                } else {
                  if (calibrations.length > 1) {
                    lol.calibrationDate = new Date(calibrations[1].completeDate)
                  } else {
                    if (lol.unit.commissionDate) {
                      lol.calibrationDate = new Date(lol.unit.commissionDate)
                    }
                  }
                }
              } else {
                if (lol.unit.commissionDate) {
                  lol.calibrationDate = new Date(lol.unit.commissionDate)
                }
              }

              if (lol.calibrationDate) {
                lol.calibrationDate.setFullYear(
                  lol.calibrationDate.getFullYear() + 1
                )
                lol.calibrationDateShow = lol.calibrationDate.toISOString()
                lol.calibrationDateShow = lol.calibrationDateShow
                  .substring(0, 10)
                  .replaceAll('-', '/')

                if (lol.calibrationDate > showCalibrationDate) {
                  indexRemoval.push(index)
                }
              } else {
                indexRemoval.push(index)
              }

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((err) => {
              console.log(err)

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
          index++
        }
        var count = 0
        for (const initIndex of indexRemoval) {
          index = initIndex - count
          this.lols.splice(index, 1)
          count++
        }

        return new Promise((resolve) => {
          resolve('Done')
        })
      })

      this.loading = false

      return new Promise((resolve) => {
        resolve('Done')
      })
    },

    retrieveDealers() {
      CustomerService.getDealers()
        .then((response) => {
          this.dealers = response.data || []
        })
        .catch((e) => {
          console.log(e)
        })
    },

    retrieveLocations() {
      if (this.$route.query.customerid) {
        LocationService.getCustomerLocations(this.$route.query.customerid)
          .then((response) => {
            this.locations = response.data || []
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        LocationService.getAll()
          .then((response) => {
            this.locations = response.data || []
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },

    async refreshLocations(customerID) {
      var flag = false
      var _this = this
      await LocationService.getCustomerLocations(customerID)
        .then(async (response) => {
          this.locations = response.data || []
          await this.locations.forEach(forEachLocation)

          async function forEachLocation(item, index) {
            if (_this.editedItem.locationID == item.locationID) {
              flag = true
            }
            return new Promise((resolve) => {
              resolve('Done')
            })
          }

          if (flag == false) {
            this.editedItem.locationID = null
          }

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    retrieveUnits() {
      UnitService.getAll()
        .then((response) => {
          this.units = response.data || []
        })
        .catch((e) => {
          console.log(e)
        })
    },

    retrieveUnassignedUnits() {
      UnitService.getUnassigned()
        .then((response) => {
          this.units = response.data || []
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createLol() {
      if (this.$route.query.locationid) {
        this.editedItem.locationID = this.$route.query.locationid
      }
      if (this.$route.query.customerid) {
        this.editedItem.customerID = this.$route.query.customerid
      }
      LolService.create(this.editedItem)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The LOL was created successfully',
            color: 'success'
          })
          this.retrieveLols()
        })
        .catch((e) => {
          console.log(e)
        })
    },

    async updateLol() {
      var tempItem = this.editedItem
      var newDealer
      await CustomerService.get(this.editedItem.customerID)
        .then((response) => {
          newDealer = response.data || {}

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
        })

      this.editedItem = tempItem
      if (
        newDealer.customerName != 'Lawrence Factor' &&
        !this.editedItem.commissionDate
      ) {
        this.editedItem.commissionDate = new Date().getTime()
      }

      LolService.update(this.editedItem.lolID, this.editedItem)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The LOL was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    deleteLol() {
      LolService.delete(this.editedItem.lolID)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The LOL was deleted successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createUnit() {
      UnitService.create(this.unitCreate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The unit was created successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updateUnit() {
      UnitService.update(this.unitUpdate.unitID, this.unitUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The unit was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createPart() {
      PartService.create(this.partCreate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was added successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updatePart() {
      PartService.update(this.partUpdate.partID, this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    deletePart() {
      PartService.delete(this.partDelete.partID)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The part was deleted successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    createCurve() {
      CurveService.create(this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The curve was added successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    updateCurve() {
      CurveService.update(this.partUpdate.curveID, this.partUpdate)
        .then((response) => {
          window._LOL2P.$emit('SHOW_SNACKBAR', {
            text: 'The curve was updated successfully',
            color: 'success'
          })
        })
        .catch((e) => {
          console.log(e)
        })
    },

    saveUnit() {
      this.unitUpdate = this.editedItem.unit
      if (this.unitUpdate.unitNumber) {
        Object.assign(this.lols[this.editedIndex].unit, this.unitUpdate)
        this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
        this.updateUnit()
      } else {
        this.snackbar('Missing unit info!', 'error', '3000')
      }
    },

    newUnitDialog() {
      this.unitCreate = {}
      this.unitCreate.lolID = this.editedItem.lolID
      this.dialogNewUnit = true
    },

    unassignedUnitDialog() {
      this.unitUpdate = {}
      this.dialogUnassignedUnit = true
    },

    newUnitDialogClose() {
      this.unitCreate = {}
      this.dialogNewUnit = false
    },

    unassignedUnitDialogClose() {
      this.unitUpdate = {}
      this.dialogUnassignedUnit = false
    },

    newUnit() {
      if (this.unitCreate.unitNumber) {
        this.unitCreate.commissionDate = new Date().getTime()
        Object.assign(this.lols[this.editedIndex].unit, this.unitCreate)
        this.lols[this.editedIndex].unitShow = true
        this.editedItem.unitShow = true
        this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
        this.createUnit()
        this.lolTab = 'tab-2'
      } else {
        this.snackbar('Missing unit info!', 'error', '3000')
      }
      this.dialogNewUnit = false
    },

    unassignedUnit() {
      this.unitUpdate.lolID = this.editedItem.lolID
      this.unitUpdate.commissionDate = new Date().getTime()
      if (this.unitUpdate.unitID) {
        Object.assign(this.lols[this.editedIndex].unit, this.unitUpdate)
        this.lols[this.editedIndex].unitShow = true
        this.editedItem.unitShow = true
        this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
        this.updateUnit()
        this.lolTab = 'tab-2'
      } else {
        this.snackbar('Missing unit info!', 'error', '3000')
      }
      this.dialogUnassignedUnit = false
    },

    addPartDialog() {
      this.partCreate = {}
      this.partCreate.unitID = this.editedItem.unit.unitID
      this.dialogAddPart = true
    },

    addPartDialogClose() {
      this.partCreate = {}
      this.dialogAddPart = false
    },

    addPart() {
      if (this.partCreate.partString) {
        this.editedItem.parts.push(this.partCreate)
        this.createPart()
      } else {
        this.snackbar('Missing part info!', 'error', '3000')
      }
      this.dialogAddPart = false
    },

    showPart(partID) {
      if (this.partShow == partID) {
        this.partShow = 0
        this.partEdit = 0
      } else {
        this.partShow = partID
        this.partEdit = 0
      }
    },

    editPart(index) {
      var partID = this.editedItem.parts[index].partID

      if (this.partEdit == partID) {
        this.partEdit = 0
        this.partBeforeEdit = {}
      } else {
        this.partEdit = partID
        this.partBeforeEdit = this.editedItem.parts[index]
        this.partBeforeEdit = Object.assign({}, this.editedItem.parts[index])
      }
    },

    savePart(index) {
      this.partUpdate = {}
      this.partUpdate = this.editedItem.parts[index]
      this.updatePart()
      if (
        this.partUpdate.curveM != this.partBeforeEdit.curveM ||
        this.partUpdate.curveB != this.partBeforeEdit.curveB
      ) {
        this.createCurve()
      }
      this.partEdit = 0
    },

    undoPart(index) {
      this.editedItem.parts.splice(index, 1, this.partBeforeEdit)
      this.partEdit = 0
    },

    deletePartDialog(index) {
      this.partDelete = this.editedItem.parts[index]
      this.partDelete.index = index
      this.dialogDeletePart = true
    },

    deletePartDialogClose() {
      this.partDelete = null
      this.dialogDeletePart = false
    },

    destroyPart() {
      this.editedItem.parts.splice(this.partDelete.index, 1)
      this.deletePart()
      this.dialogDeletePart = false
    },

    clearCalibrationSheet() {
      this.editedItem.lolNumber = null
      this.editedIndex = -1
      this.calibrationSheet = true
    },

    clearLolSheet() {
      this.editedItem.lolNumber = null
      this.editedItem.lolName = null
      this.editedItem.lolNotes = null
      this.editedItem.debugMode = null
      this.editedItem.customerID = null
      this.editedItem.locationID = null
      this.editedItem.unit = null
      this.editedItem.parts = null
      this.editedIndex = -1
      this.lolTab = 1
    },

    async editItem(item) {
      await CalibrationService.getLolCalibrations(item.lolID)
        .then((response) => {
          var calibration = response.data || []

          if (calibration.length) {
            if (calibration.length > 1) {
              if (calibration[0].completeDate) {
                item.calibrationDate = new Date(calibration[0].completeDate)
              } else {
                item.calibrationDate = new Date(calibration[1].completeDate)
              }
            } else {
              if (calibration[0].completeDate) {
                item.calibrationDate = new Date(calibration[0].completeDate)
              } else {
                item.calibrationDate = new Date(item.unit.commissionDate)
              }
            }
          } else {
            item.calibrationDate = new Date(item.unit.commissionDate)
          }

          item.calibrationDate.setFullYear(
            item.calibrationDate.getFullYear() + 1
          )
          item.calibrationDate = item.calibrationDate.toISOString()
          item.calibrationDate = item.calibrationDate
            .substring(0, 10)
            .replaceAll('-', '/')

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          let message = 'There was an error retrieving calibration'
          let color = 'error'
          this.snackbar(message, color, 0)
        })

      if (item.lastPowerOn != null) {
        item.lastPowerOnShow = item.lastPowerOn
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.lastSync != null) {
        item.lastSyncShow = item.lastSync
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.commissionDate != null) {
        item.commissionDateShow = item.commissionDate
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.decommissionDate != null) {
        item.decommissionDateShow = item.decommissionDate
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.unit.manufactureDate != null) {
        item.unit.manufactureDateShow = item.unit.manufactureDate
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.unit.commissionDate != null) {
        item.unit.commissionDateShow = item.unit.commissionDate
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }
      if (item.unit.decommissionDate != null) {
        item.unit.decommissionDateShow = item.unit.decommissionDate
          .substring(0, 19)
          .replaceAll('-', '/')
          .replace('T', ' ')
      }

      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.refreshLocations(this.editedItem.customerID)
      this.lolSheet = true
      this.lolTab = 'tab-1'
    },

    deleteItem(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.lols.splice(this.editedIndex, 1)
      this.deleteLol()
      this.closeDelete()
    },

    close() {
      this.lolSheet = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.lols[this.editedIndex], this.editedItem)
        this.updateLol()
      } else {
        this.lols.push(this.editedItem)
        this.createLol()
      }
      this.close()
    },

    editModeToggle(toggle) {
      if (toggle) {
        if (this.checkRole('lf')) {
          this.editMode = true
        } else {
          this.editModeDealer = true
        }
      } else {
        this.editMode = false
        this.editModeDealer = false
      }
    },

    openCalibrationDialog() {
      this.dialogCalibration = true
    },

    async performCalibration() {
      this.unitCalibration.lolID = this.editedItem.lolID
      this.calibrationData.lolID = this.editedItem.lolID
      this.calibrationData.beforeUnitID = this.editedItem.unit.unitID
      this.calibrationData.calibrationDate = new Date().getTime()
      let d = new Date()
      let n = d.toJSON()
      let ymd = n.substring(0, 10).replace(/-/g, '')
      let hmsm = n
        .substring(11, 23)
        .replace(/:/g, '')
        .replace('.', '')
      this.calibrationData.calibrationNumber = ymd + hmsm

      if (this.calibrationStep.includes('Unassigned')) {
        this.calibrationData.afterUnitID = this.unitCalibration.unitID

        UnitService.update(this.unitCalibration.unitID, this.unitCalibration)
          .then((response) => {
            this.snackbar(
              'Success! The unit was assigned successfully',
              'success'
            )
          })
          .catch((e) => {
            console.log(e)
          })
      } else if (this.calibrationStep.includes('New')) {
        await UnitService.create(this.unitCalibration)
          .then((response) => {
            this.snackbar(
              'Success! The unit was created successfully',
              'success'
            )
            this.calibrationData.afterUnitID = response.data.unitID

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        this.calibrationData.afterUnitID = this.editedItem.unit.unitID
      }

      CalibrationService.create(this.calibrationData)
        .then((response) => {
          this.snackbar(
            'Success! The calibration was performed successfully',
            'success'
          )
          this.lolSheet = false
          this.retrieveLols()
        })
        .catch((e) => {
          console.log(e)
        })

      this.calibrationStep = 'initial'
      this.dialogCalibration = false
    },

    decommissionLol() {
      if (!this.editedItem.decommissionDate) {
        var decommissionDate = new Date().getTime()
        var updateLol = { decommissionDate: decommissionDate }
        LolService.update(this.editedItem.lolID, updateLol)
          .then((response) => {
            this.snackbar('Success! LOL successfully decommissioned', 'success')
            this.dialogDecommissionLol = false
            this.lolSheet = false
            this.retrieveLols()
          })
          .catch((e) => {
            console.log(e)
            this.snackbar(
              'Error! There was an error decommissioning LOL',
              'error',
              0
            )
          })
      }
    },

    manufactureUnit() {
      if (!this.editedItem.unit.manufactureDate) {
        var manufactureDate = new Date().getTime()
        var updateUnit = { manufactureDate: manufactureDate }
        UnitService.update(this.editedItem.unit.unitID, updateUnit)
          .then((response) => {
            this.snackbar(
              'Success! Unit successfully marked as manufactured',
              'success'
            )
            this.dialogManufactureUnit = false
            this.lolSheet = false
            this.retrieveLols()
          })
          .catch((e) => {
            console.log(e)
            this.snackbar(
              'Error! There was an error marking Unit as manufactured',
              'error',
              0
            )
          })
      }
    },

    openDialogCredentials(formField) {
      this.credentials = {
        username: '',
        password: '',
        formField: formField
      }
      this.dialogCredentials = true
    },

    closeDialogCredentials() {
      this.credentials = {
        username: '',
        password: '',
        formField: ''
      }
      this.dialogCredentials = false
    },

    credentialsConfirm(formField) {
      AuthService.checkTech(this.credentials)
        .then((response) => {
          if (
            response.roles.includes('ROLE_LFADMIN') ||
            response.roles.includes('ROLE_LFTECH') ||
            response.roles.includes('ROLE_LFBILLING')
          ) {
            var date = new Date().toISOString()
            var dateShow = date
              .substring(0, 19)
              .replaceAll('-', '/')
              .replace('T', ' ')
            if (formField == 'recallTicket.requestBy') {
              this.recallTicket.requestByID = response.userID
              this.recallTicket.requestBy = response.fullName
              this.recallTicket.requestDate = date
              this.recallTicket.requestDateShow = dateShow
            } else if (formField == 'recallTicket.authorizedBy') {
              if (response.roles.includes('ROLE_LFADMIN')) {
                this.recallTicket.authorizedByID = response.userID
                this.recallTicket.authorizedBy = response.fullName
                this.recallTicket.authorizedDate = date
                this.recallTicket.authorizedDateShow = dateShow
              } else {
                this.snackbar(
                  'Error! Sorry, this function is only for admins',
                  'error'
                )
              }
            } else if (formField == 'receiving.receivedBy') {
              this.receiving.receivedByID = response.userID
              this.receiving.receivedBy = response.fullName
              this.receiving.receiveDate = date
              this.receiving.receiveDateShow = dateShow
            } else if (formField == 'order.orderedBy') {
              this.order.orderedByID = response.userID
              this.order.orderedBy = response.fullName
              this.order.orderDate = date
              this.order.orderDateShow = dateShow
            } else if (formField == 'serviceTicket.serviceBy') {
              this.serviceTicket.serviceByID = response.userID
              this.serviceTicket.serviceBy = response.fullName
              this.serviceTicket.serviceDate = date
              this.serviceTicket.serviceDateShow = dateShow
            } else if (formField == 'serviceTicket.laborBy') {
              this.serviceTicket.laborByID = response.userID
              this.serviceTicket.laborBy = response.fullName
              this.serviceTicket.laborDate = date
              this.serviceTicket.laborDateShow = dateShow
            } else if (formField == 'fulfill.fulfilledBy') {
              this.fulfill.fulfilledByID = response.userID
              this.fulfill.fulfilledBy = response.fullName
              this.fulfill.fulfillDate = date
              this.fulfill.fulfillDateShow = dateShow
            }
            this.closeDialogCredentials()
          } else {
            this.snackbar(
              'Error! Sorry, this function is only for LF users',
              'error'
            )
          }
        })
        .catch((e) => {
          console.log(e)
          this.snackbar('Incorrect credentials!', 'error')
        })
    },

    clearCredentials(formField) {
      if (formField == 'recallTicket.requestBy') {
        this.recallTicket.requestByID = null
        this.recallTicket.requestBy = null
        this.requestByKey += 1
      } else if (formField == 'recallTicket.authorizedBy') {
        this.recallTicket.authorizedByID = null
        this.recallTicket.authorizedBy = null
        this.authorizedByKey += 1
      } else if (formField == 'receiving.receivedBy') {
        this.receiving.receivedByID = null
        this.receiving.receivedBy = null
        this.receivedByKey += 1
      } else if (formField == 'order.orderedBy') {
        this.order.orderedByID = null
        this.order.orderedBy = null
        this.orderedByKey += 1
      } else if (formField == 'serviceTicket.serviceBy') {
        this.serviceTicket.serviceByID = null
        this.serviceTicket.serviceBy = null
        this.serviceByKey += 1
      } else if (formField == 'serviceTicket.laborBy') {
        this.serviceTicket.laborByID = null
        this.serviceTicket.laborBy = null
        this.laborByKey += 1
      } else if (formField == 'fulfill.fulfilledBy') {
        this.fulfill.fulfilledByID = null
        this.fulfill.fulfilledBy = null
        this.fulfilledByKey += 1
      }
    },

    openDialogCalibrationSwap(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.dialogCalibrationSwap = true
    },

    async toggleCalibrationSwap() {
      await CalibrationService.update(
        this.editedItem.calibration.calibrationID,
        { calibrationSwap: !this.editedItem.calibration.calibrationSwap }
      )
        .then(async (response) => {
          this.snackbar('Success! Calibration swap was toggled', 'success')
          this.dialogCalibrationSwap = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    async openRecallTicketDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.calibrationID) {
        this.recallTicket = this.editedItem.calibration.recallTicket
        this.recallTicket.partSearch = [...this.editedItem.unit.parts]

        if (this.recallTicket.requestByID) {
          this.recallTicket.requestDateShow = this.recallTicket.requestDate
            .substring(0, 19)
            .replaceAll('-', '/')
            .replace('T', ' ')
          await AuthService.get(this.recallTicket.requestByID)
            .then((response) => {
              this.recallTicket.requestBy = response.data.fullName
            })
            .catch((e) => {
              console.log(e)
            })
        }

        if (this.recallTicket.authorizedByID) {
          this.recallTicket.authorizedDateShow = this.recallTicket.authorizedDate
            .substring(0, 19)
            .replaceAll('-', '/')
            .replace('T', ' ')
          await AuthService.get(this.recallTicket.authorizedByID)
            .then((response) => {
              this.recallTicket.authorizedBy = response.data.fullName
            })
            .catch((e) => {
              console.log(e)
            })
        }

        if (this.editedItem.calibration.recallTicketDate) {
          this.editedItem.calibration.recallTicketDateShow = this.editedItem.calibration.recallTicketDate
            .substring(0, 19)
            .replaceAll('-', '/')
            .replace('T', ' ')
        }

        await CalibrationRecallTicketPartService.getCalibrationRecallTicketParts(
          this.recallTicket.calibrationRecallTicketID
        )
          .then(async (response) => {
            this.recallTicket.recallTicketPart = response.data
            this.recallTicket.recallTicketPartBefore = response.data

            for (const recallPart of this.recallTicket.recallTicketPart) {
              await PartService.get(recallPart.partID).then((response) => {
                recallPart.partName = response.data.partName
                recallPart.partString = response.data.partString

                return new Promise((resolve) => {
                  resolve('Done')
                })
              })
              let index = this.recallTicket.partSearch.findIndex(
                (part) => part.partID == recallPart.partID
              )
              this.recallTicket.partSearch.splice(index, 1)
            }

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            return new Promise((resolve) => {
              resolve('Done')
            })
          })
      } else {
        this.recallTicket = {
          calibrationID: null,
          contactName: null,
          contactEmail: null,
          reason: null,
          recallTicketNotes: null,
          requestedByID: null,
          requestDate: null,
          authorizedByID: null,
          authorizeDate: null,
          partSearch: this.editedItem.unit.parts,
          recallTicketPart: []
        }
      }
      this.dialogRecallTicket = true
    },

    addPartRecallTicket() {
      this.recallTicket.addPart.calibrationRecallTicketID = this.recallTicket.calibrationRecallTicketID
      CalibrationRecallTicketPartService.create(this.recallTicket.addPart)
        .then((response) => {
          this.recallTicket.addPart.calibrationRecallTicketPartID =
            response.data.calibrationRecallTicketPartID
          this.recallTicket.recallTicketPart.push(this.recallTicket.addPart)

          let index = this.recallTicket.partSearch.findIndex(
            (part) => part.partID == this.recallTicket.addPart.partID
          )
          this.recallTicket.partSearch.splice(index, 1)

          this.recallTicket.addPart = null
        })
        .catch((e) => {
          console.log(e)
        })
    },

    removePartRecallTicket(index) {
      CalibrationRecallTicketPartService.delete(
        this.recallTicket.recallTicketPart[index].calibrationRecallTicketPartID
      ).catch((e) => {
        console.log(e)
      })

      this.recallTicket.partSearch.push(
        this.recallTicket.recallTicketPart[index]
      )
      this.recallTicket.recallTicketPart.splice(index, 1)
      this.recallTicketPartKey += 1
    },

    async saveRecallTicket() {
      this.saving.show = true
      if (this.recallTicket.calibrationRecallTicketID) {
        await CalibrationRecallTicketService.update(
          this.recallTicket.calibrationRecallTicketID,
          this.recallTicket
        )
          .then(async (response) => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Recall Ticket saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
      } else {
        let d = new Date()
        let n = d.toJSON()
        let ymd = n.substring(0, 10).replace(/-/g, '')
        let hmsm = n
          .substring(11, 23)
          .replace(/:/g, '')
          .replace('.', '')
        let calibration = {
          lolID: this.editedItem.lolID,
          calibrationNumber: ymd + hmsm
        }
        await CalibrationService.create(calibration)
          .then((response) => {
            this.recallTicket.calibrationID = response.data.calibrationID

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false

            return new Promise((resolve) => {
              resolve('Done')
            })
          })

        await CalibrationRecallTicketService.create(this.recallTicket)
          .then(async (response) => {
            this.recallTicket.calibrationRecallTicketID =
              response.data.calibrationRecallTicketID

            if (this.recallTicket.recallTicketPart.length) {
              for (const part of this.recallTicket.recallTicketPart) {
                part.recallTicketID = this.recallTicket.calibrationRecallTicketID

                await CalibrationRecallTicketPartService.create(part)
                  .then((response) => {
                    return new Promise((resolve) => {
                      resolve('Done')
                    })
                  })
                  .catch((e) => {
                    console.log(e)

                    return new Promise((resolve) => {
                      resolve('Done')
                    })
                  })
              }
            }
            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Recall Ticket saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
      }
      await this.retrieveCalibrations()

      return new Promise((resolve) => {
        resolve('Done')
      })
    },

    async completeRecallTicket() {
      await this.saveRecallTicket()

      if (!this.recallTicket.contactName) {
        this.snackbar('Error! Contact name cannot be left blank.', 'error')
        return
      }

      if (!this.recallTicket.contactEmail) {
        this.snackbar('Error! Contact email cannot be left blank.', 'error')
        return
      }

      if (!this.recallTicket.reason) {
        this.snackbar('Error! Reason cannot be left blank.', 'error')
        return
      }

      if (
        this.editedItem.calibration.calibrationFlag &&
        this.recallTicket.requestByID == null
      ) {
        this.snackbar(
          'Error! Request By cannot be left blank on a flagged calibration.',
          'error'
        )
        return
      }

      if (
        this.editedItem.calibration.calibrationFlag &&
        this.recallTicket.authorizedByID == null
      ) {
        this.snackbar(
          'Error! Authorized By cannot be left blank on a flagged calibration.',
          'error'
        )
        return
      }

      await CalibrationService.update(this.recallTicket.calibrationID, {
        recallTicketDate: new Date().toISOString()
      })
        .then(async (response) => {
          this.snackbar('Success! Recall ticket was marked complete', 'success')
          this.dialogRecallTicket = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openScheduleDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.calendarStart = new Date()
      this.calendarStart.setDate(1)
      this.calendarStart.setMonth(this.calendarStart.getMonth() + 1)

      this.dialogSchedule = true
    },

    async getCalendarEvents() {
      await CalibrationService.getAllFull().then(async (response) => {
        this.calibrations = response.data
        this.calendarEvents.push({})
        this.calendarEvents.pop()

        if (this.calendarEvents.length == 0) {
          for (const calibration of this.calibrations) {
            if (calibration.scheduleDate && !calibration.completeDate) {
              await LolService.get(calibration.lolID).then((response) => {
                calibration.lol = response.data

                return new Promise((resolve) => {
                  resolve('Done')
                })
              })

              if (calibration.order) {
                calibration.schedule = calibration.order
                var d = calibration.schedule.calibrationScheduleDate.split(
                  /\D+/
                )
                d = new Date(
                  Date.UTC(d[0], --d[1], d[2], d[3], d[4], d[5], d[6])
                )
                d.setHours(12)
                d.setMinutes(0)
                d.setSeconds(0)
                d.setMilliseconds(0)

                this.calendarEvents.push({
                  name: calibration.lol.lolNumber,
                  start: d,
                  end: d
                })
              }
            }
          }
        }

        return new Promise((resolve) => {
          resolve('Done')
        })
      })
    },

    confirmSchedule({ date }) {
      this.schedule.calibrationScheduleDate = date
      this.schedule.calibrationScheduleDateShow = this.schedule.calibrationScheduleDate.replaceAll(
        '-',
        '/'
      )
      this.dialogConfirmSchedule = true
    },

    confirmAutoSchedule() {
      var d = new Date()
      d.setMonth(d.getMonth() + 1)
      d.setDate(1)
      d.setHours(12)
      d.setMinutes(0)
      d.setSeconds(0)
      d.setMilliseconds(0)

      var initial = new Date()
      initial.setMonth(initial.getMonth() + 1)
      initial.setDate(1)
      initial.setHours(12)
      initial.setMinutes(0)
      initial.setSeconds(0)
      initial.setMilliseconds(0)

      var index
      for (let i = 0; i < 7; i++) {
        if (d.getDay() == 1) {
          do {
            index = this.calendarEvents.findIndex(
              (event) => event.start.toISOString() == d.toISOString()
            )
            if (index != -1) {
              d.setDate(d.getDate() + 7)
            } else {
              break
            }
          } while (d.getMonth() == initial.getMonth())
          break
        } else {
          d.setDate(d.getDate() + 1)
        }
      }

      if (index != -1) {
        d = new Date(initial)
        for (let i = 0; i < 7; i++) {
          if (d.getDay() == 3) {
            do {
              index = this.calendarEvents.findIndex(
                (event) => event.start.toISOString() == d.toISOString()
              )
              if (index != -1) {
                d.setDate(d.getDate() + 7)
              } else {
                break
              }
            } while (d.getMonth() == initial.getMonth())
            break
          } else {
            d.setDate(d.getDate() + 1)
          }
        }
      }

      if (index != -1) {
        d = new Date(initial)
        for (let i = 0; i < 7; i++) {
          if (d.getDay() == 5) {
            do {
              index = this.calendarEvents.findIndex(
                (event) => event.start.toISOString() == d.toISOString()
              )
              if (index != -1) {
                d.setDate(d.getDate() + 7)
              } else {
                break
              }
            } while (d.getMonth() == initial.getMonth())
            break
          } else {
            d.setDate(d.getDate() + 1)
          }
        }
      }

      if (index == -1) {
        this.schedule.calibrationScheduleDate = d.toISOString().substring(0, 10)
        this.schedule.calibrationScheduleDateShow = this.schedule.calibrationScheduleDate.replaceAll(
          '-',
          '/'
        )
        this.dialogConfirmSchedule = true
      } else {
        this.snackbar(
          'Error! No available day found for auto-schedule.',
          'error',
          '6000'
        )
      }
    },

    scheduleDetails() {
      this.schedule.schedulePhoneNotes = null
      this.dialogScheduleDetails = true
      this.dialogConfirmSchedule = false
    },

    scheduleDay() {
      var today = new Date()
      this.schedule.calibrationID = this.editedItem.calibration.calibrationID
      this.schedule.scheduleEmailDate = today.toISOString()
      this.schedule.schedulePhoneDate = today.toISOString()
      this.schedule.calibrationScheduleDate = `${this.schedule.calibrationScheduleDate}T12:00:00.000Z`

      CalibrationOrderService.create(this.schedule)
        .then((response) => {
          this.schedule.calibrationOrderID = response.data.calibrationOrderID
          CalibrationService.update(this.editedItem.calibration.calibrationID, {
            scheduleDate: today.toISOString()
          })
            .then((response) => {
              var d = `${this.schedule.calibrationScheduleDate}T12:00:00.000Z`
              d = d.split(/\D+/)
              d = new Date(Date.UTC(d[0], --d[1], d[2], d[3], d[4], d[5], d[6]))
              d.setHours(12)
              d.setMinutes(0)
              d.setSeconds(0)
              d.setMilliseconds(0)

              this.calendarEvents.push({
                name: this.editedItem.lolNumber,
                start: d,
                end: d
              })

              CalibrationOrderService.emailSchedule(
                this.schedule.calibrationOrderID
              )
                .then((response) => {
                  this.snackbar(
                    'Success! Calibration scheduled.',
                    'success',
                    '6000'
                  )
                  this.dialogScheduleDetails = false
                  this.dialogSchedule = false
                  this.retrieveCalibrations()
                })
                .catch((e) => {
                  this.snackbar(
                    'Error! There was an error sending the schedule confirmation email.',
                    'error',
                    '6000'
                  )
                  console.log(e)
                })
            })
            .catch((e) => {
              this.snackbar(
                'Error! There was an error scheduling the calibration.',
                'error',
                '6000'
              )
              console.log(e)
            })
        })
        .catch((e) => {
          this.snackbar(
            'Error! There was an error scheduling the calibration.',
            'error',
            '6000'
          )
          console.log(e)
        })
    },

    async openReceivingDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.receiving) {
        this.receiving = this.editedItem.calibration.receiving
        this.receiving.addItem = {
          description: null,
          quantity: null
        }
        if (this.receiving.receivedByID) {
          await AuthService.get(this.receiving.receivedByID).then(
            (response) => {
              this.receiving.receivedBy = response.data.fullName

              return new Promise((resolve) => {
                resolve('Done')
              })
            }
          )
        }
        if (this.receiving.receiveDate) {
          this.receiving.receiveDateShow = this.receiving.receiveDate
            .substring(0, 10)
            .replaceAll('-', '/')
        }
      } else {
        this.receiving = {
          addItem: {
            description: null,
            quantity: null
          }
        }
      }

      this.receiving.calibrationID = this.editedItem.calibration.calibrationID
      this.receiving.itemSearch = ['LOL Unit', 'Tablet']
      this.dialogReceiving = true
    },

    async saveReceiving() {
      this.saving.show = true
      if (this.receiving.calibrationReceivingID) {
        await CalibrationReceivingService.update(
          this.receiving.calibrationReceivingID,
          this.receiving
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Receiving saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationReceivingService.create(this.receiving)
          .then((response) => {
            this.receiving.calibrationReceivingID =
              response.data.calibrationReceivingID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Receiving saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    addItemReceiving() {
      if (!this.receiving.addItem.description) {
        this.snackbar('Error! No item selected', 'error')
        return
      }

      if (
        !this.receiving.addItem.quantity ||
        Number.isInteger(this.receiving.addItem.quantity) ||
        this.receiving.addItem.quantity < 0
      ) {
        this.snackbar('Error! Quantity input invalid', 'error')
        return
      }

      if (this.receiving) {
        this.receiving.addItem.calibrationReceivingID = this.receiving.calibrationReceivingID
        CalibrationReceivingItemService.create(this.receiving.addItem)
          .then((response) => {
            this.receiving.addItem.calibrationReceivingItemID =
              response.data.calibrationReceivingItemID
            this.receiving.receivingItem.push(response.data)

            this.receiving.addItem = {
              description: '',
              quantity: ''
            }

            // let index = this.receiving.itemSearch.indexOf(this.receiving.addItem.description)
            // this.receiving.itemSearch.splice(index, 1)
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        CalibrationReceivingService.create(this.receiving)
          .then((response) => {
            this.editedItem.calibration.receiving = response.data
            this.receiving.addItem.calibrationReceivingID =
              response.data.calibrationReceivingID

            CalibrationReceivingItemService.create(this.receiving.addItem)
              .then((response) => {
                this.receiving.addItem.calibrationReceivingItemID =
                  response.data.calibrationReceivingItemID
                this.receiving.receivingItem.push(response.data)

                this.receiving.addItem = {
                  description: null,
                  quantity: null
                }

                // let index = this.receiving.itemSearch.indexOf(this.receiving.addItem.description)
                // this.receiving.itemSearch.splice(index, 1)
              })
              .catch((e) => {
                console.log(e)
              })
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },

    removeItemReceiving(index) {
      CalibrationReceivingItemService.delete(
        this.receiving.receivingItem[index].calibrationReceivingItemID
      )
        .then(() => {
          this.receiving.receivingItem.splice(index, 1)
          this.snackbar('Success! Removed receiving item', 'success')
        })
        .catch((e) => {
          console.log(e)
          this.snackbar(
            'Error! There was an error removing receiving item',
            'error'
          )
        })
    },

    async completeReceiving() {
      await this.saveReceiving()

      if (!this.receiving.receivedBy) {
        this.snackbar('Error! Received By cannot be left blank.', 'error')
        return
      }

      var receivingComplete
      if (!this.editedItem.calibration.calibrationSwap) {
        receivingComplete = {
          receiveDate: new Date().toISOString()
        }
      } else {
        receivingComplete = {
          receiveDate: new Date().toISOString(),
          completeDate: new Date().toISOString()
        }
      }

      await CalibrationService.update(
        this.receiving.calibrationID,
        receivingComplete
      )
        .then(async (response) => {
          await CalibrationReceivingService.emailReceiving(
            this.receiving.calibrationReceivingID
          )
            .then(async (response) => {
              this.snackbar('Success! Receiving was marked complete', 'success')
              this.dialogReceiving = false
              await this.retrieveCalibrations()

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((e) => {
              this.snackbar(
                'Error! There was an error sending the receiving confirmation email.',
                'error',
                '6000'
              )
              console.log(e)
            })

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    async openOrderDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.order) {
        this.order = this.editedItem.calibration.order

        if (this.order.orderedByID) {
          await AuthService.get(this.order.orderedByID).then((response) => {
            this.order.orderedBy = response.data.fullName

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
        }
        if (this.order.orderDate) {
          this.order.orderDateShow = this.order.orderDate
            .substring(0, 10)
            .replaceAll('-', '/')
        }
      }

      this.order.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogOrder = true
    },

    async saveOrder() {
      this.saving.show = true
      if (this.order.calibrationOrderID) {
        await CalibrationOrderService.update(
          this.order.calibrationOrderID,
          this.order
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Order saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationOrderService.create(this.order)
          .then((response) => {
            this.order.calibrationOrderID = response.data.calibrationOrderID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Order saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    async completeOrder() {
      await this.saveOrder()
      await CalibrationService.update(this.order.calibrationID, {
        orderDate: new Date().toISOString()
      })
        .then(async (response) => {
          await CalibrationOrderService.emailOrder(
            this.order.calibrationOrderID
          )
            .then(async (response) => {
              this.snackbar('Success! Order was marked complete', 'success')
              this.dialogOrder = false
              await this.retrieveCalibrations()

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((e) => {
              this.snackbar(
                'Error! There was an error sending the internal order complete email.',
                'error',
                '6000'
              )
              console.log(e)
            })

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          this.snackbar(
            'Error! There was an error marking the order complete.',
            'error',
            '6000'
          )
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openInventoryInDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.inventoryIn) {
        this.inventoryIn = this.editedItem.calibration.inventoryIn
      }

      this.inventoryIn.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogInventoryIn = true
    },

    async saveInventoryIn() {
      this.saving.show = true
      if (this.inventoryIn.calibrationInventoryInID) {
        await CalibrationInventoryInService.update(
          this.inventoryIn.calibrationInventoryInID,
          this.inventoryIn
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Inventory In saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationInventoryInService.create(this.inventoryIn)
          .then((response) => {
            this.inventoryIn.calibrationInventoryInID =
              response.data.calibrationInventoryInID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Inventory In saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    async completeInventoryIn() {
      await this.saveInventoryIn()
      await CalibrationService.update(this.inventoryIn.calibrationID, {
        inventoryInDate: new Date().toISOString()
      })
        .then(async (response) => {
          this.snackbar('Success! Inventory In was marked complete', 'success')
          this.dialogInventoryIn = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    async openServiceTicketDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.serviceTicket) {
        this.serviceTicket = this.editedItem.calibration.serviceTicket
        this.serviceTicket.partSearch = [...this.editedItem.unit.parts]
        this.serviceTicket.addMaterial = {
          partNumber: null,
          description: null,
          quantity: null
        }

        if (this.serviceTicket.serviceByID) {
          this.serviceTicket.serviceDateShow = this.serviceTicket.serviceDate
            .substring(0, 19)
            .replaceAll('-', '/')
            .replace('T', ' ')
          await AuthService.get(this.serviceTicket.serviceByID)
            .then((response) => {
              this.serviceTicket.serviceBy = response.data.fullName
            })
            .catch((e) => {
              console.log(e)
            })
        }
        if (this.serviceTicket.laborByID) {
          await AuthService.get(this.serviceTicket.laborByID).then(
            (response) => {
              this.serviceTicket.laborBy = response.data.fullName

              return new Promise((resolve) => {
                resolve('Done')
              })
            }
          )
        }
        if (this.serviceTicket.laborDate) {
          this.serviceTicket.laborDateShow = this.serviceTicket.laborDate
            .substring(0, 10)
            .replaceAll('-', '/')
        }

        await CalibrationServiceTicketPartService.getCalibrationServiceTicketParts(
          this.serviceTicket.calibrationServiceTicketID
        )
          .then(async (response) => {
            this.serviceTicket.serviceTicketPart = response.data
            this.serviceTicket.serviceTicketPartBefore = response.data

            for (const servicePart of this.serviceTicket.serviceTicketPart) {
              await PartService.get(servicePart.partID).then((response) => {
                servicePart.partName = response.data.partName
                servicePart.partString = response.data.partString

                return new Promise((resolve) => {
                  resolve('Done')
                })
              })
              let index = this.serviceTicket.partSearch.findIndex(
                (part) => part.partID == servicePart.partID
              )
              this.serviceTicket.partSearch.splice(index, 1)
            }

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            return new Promise((resolve) => {
              resolve('Done')
            })
          })
      } else {
        this.serviceTicket = {
          partSearch: this.editedItem.unit.parts,
          serviceTicketPart: [],
          addMaterial: {
            partNumber: null,
            description: null,
            quantity: null
          }
        }
      }

      this.serviceTicket.calibrationID = this.editedItem.calibration.calibrationID
      // this.serviceTicket.materialSearch = ['LOL Unit', 'Tablet']
      this.dialogServiceTicket = true
    },

    async saveServiceTicket() {
      this.saving.show = true
      if (this.serviceTicket.calibrationServiceTicketID) {
        await CalibrationServiceTicketService.update(
          this.serviceTicket.calibrationServiceTicketID,
          this.serviceTicket
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Service ticket saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationServiceTicketService.create(this.serviceTicket)
          .then((response) => {
            this.serviceTicket.calibrationServiceTicketID =
              response.data.calibrationServiceTicketID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Service ticket saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    addPartServiceTicket() {
      this.serviceTicket.addPart.calibrationServiceTicketID = this.serviceTicket.calibrationServiceTicketID
      CalibrationServiceTicketPartService.create(this.serviceTicket.addPart)
        .then((response) => {
          this.serviceTicket.addPart.calibrationServiceTicketPartID =
            response.data.calibrationServiceTicketPartID
          this.serviceTicket.serviceTicketPart.push(this.serviceTicket.addPart)

          let index = this.serviceTicket.partSearch.findIndex(
            (part) => part.partID == this.serviceTicket.addPart.partID
          )
          this.serviceTicket.partSearch.splice(index, 1)

          this.serviceTicket.addPart = null
        })
        .catch((e) => {
          console.log(e)
        })
    },

    removePartServiceTicket(index) {
      CalibrationServiceTicketPartService.delete(
        this.serviceTicket.serviceTicketPart[index]
          .calibrationServiceTicketPartID
      ).catch((e) => {
        console.log(e)
      })

      this.serviceTicket.partSearch.push(
        this.serviceTicket.serviceTicketPart[index]
      )
      this.serviceTicket.serviceTicketPart.splice(index, 1)
      this.serviceTicketPartKey += 1
    },

    addMaterialServiceTicket() {
      if (!this.serviceTicket.addMaterial.partNumber) {
        this.snackbar('Error! No part number input', 'error')
        return
      }

      if (!this.serviceTicket.addMaterial.description) {
        this.snackbar('Error! No description input', 'error')
        return
      }

      if (
        !this.serviceTicket.addMaterial.quantity ||
        Number.isInteger(this.serviceTicket.addMaterial.quantity) ||
        this.serviceTicket.addMaterial.quantity < 0
      ) {
        this.snackbar('Error! Quantity input invalid', 'error')
        return
      }

      if (this.serviceTicket) {
        this.serviceTicket.addMaterial.calibrationServiceTicketID = this.serviceTicket.calibrationServiceTicketID
        CalibrationServiceTicketMaterialService.create(
          this.serviceTicket.addMaterial
        )
          .then((response) => {
            console.log(response.data)
            this.serviceTicket.addMaterial.calibrationServiceTicketMaterialID =
              response.data.calibrationServiceTicketMaterialID
            this.serviceTicket.serviceTicketMaterial.push(response.data)

            this.serviceTicket.addMaterial = {
              partNumber: '',
              description: '',
              quantity: ''
            }
          })
          .catch((e) => {
            console.log(e)
          })
      } else {
        CalibrationServiceTicketService.create(this.serviceTicket)
          .then((response) => {
            this.editedItem.calibration.serviceTicket = response.data
            this.serviceTicket.addMaterial.calibrationServiceTicketID =
              response.data.calibrationServiceTicketID

            CalibrationServiceTicketMaterialService.create(
              this.serviceTicket.addMaterial
            )
              .then((response) => {
                this.serviceTicket.addMaterial.calibrationServiceTicketMaterialID =
                  response.data.calibrationServiceTicketMaterialID
                this.serviceTicket.serviceTicketMaterial.push(response.data)

                this.serviceTicket.addMaterial = {
                  partNumber: null,
                  description: null,
                  quantity: null
                }
              })
              .catch((e) => {
                console.log(e)
              })
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },

    removeMaterialServiceTicket(index) {
      CalibrationServiceTicketMaterialService.delete(
        this.serviceTicket.serviceTicketMaterial[index]
          .calibrationServiceTicketMaterialID
      )
        .then(() => {
          this.serviceTicket.serviceTicketMaterial.splice(index, 1)
          this.snackbar('Success! Removed service ticket material', 'success')
        })
        .catch((e) => {
          console.log(e)
          this.snackbar(
            'Error! There was an error removing service ticket material',
            'error'
          )
        })
    },

    async completeServiceTicket() {
      await this.saveServiceTicket()

      if (!this.serviceTicket.serviceByID) {
        this.snackbar('Error! Service By cannot be left blank.', 'error')
        return
      }

      if (!this.serviceTicket.laborHours) {
        this.snackbar('Error! Labor Hours cannot be left blank.', 'error')
        return
      }

      if (!this.serviceTicket.laborByID) {
        this.snackbar('Error! Labor By cannot be left blank.', 'error')
        return
      }

      await CalibrationService.update(this.serviceTicket.calibrationID, {
        serviceTicketDate: new Date().toISOString()
      })
        .then(async (response) => {
          this.snackbar(
            'Success! Service ticket was marked complete',
            'success'
          )
          this.dialogServiceTicket = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openCalibrationTicketDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.calibrationTicket.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogCalibrationTicket = true
    },

    addDropFileCalibrationTicket(e) {
      this.calibrationTicket.file = e.dataTransfer.files[0]
    },

    addClickFileCalibrationTicket() {
      var id = this.$refs.calibrationTicketFileInput.$el.lastChild.firstChild
        .firstChild.lastChild.id
      document.querySelector(`input#${id}`).click()
    },

    async completeCalibrationTicket() {
      if (!this.calibrationTicket.file) {
        this.snackbar('Error! No file was uploaded.', 'error')
        return
      }

      const fd = new FormData()
      var ext = this.calibrationTicket.file.type.replace(/(.*)\//g, '')
      fd.append(
        'calibrationticketfile',
        this.calibrationTicket.file,
        `${this.calibrationTicket.calibrationID}.${ext}`
      )

      await UploadService.createCalibrationTicket(fd)
        .then((res) => {
          // this.snackbar('Success! The calibration ticket was uploaded successfully', 'success')

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          this.snackbar(
            'Error! There was an error uploading the calibration ticket.',
            'error',
            '6000'
          )

          return new Promise((resolve) => {
            resolve('Done')
          })
        })

      await CalibrationService.update(this.calibrationTicket.calibrationID, {
        calibrationTicketDate: new Date().toISOString()
      })
        .then(async (response) => {
          this.snackbar(
            'Success! Calibration ticket was marked complete',
            'success'
          )
          this.dialogCalibrationTicket = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openChecklistDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      this.checklist.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogChecklist = true
    },

    addDropFileChecklist(e) {
      this.checklist.file = e.dataTransfer.files[0]
    },

    addClickFileChecklist() {
      var id = this.$refs.checklistFileInput.$el.lastChild.firstChild.firstChild
        .lastChild.id
      document.querySelector(`input#${id}`).click()
    },

    async completeChecklist() {
      if (!this.checklist.file) {
        this.snackbar('Error! No file was uploaded.', 'error')
        return
      }

      const fd = new FormData()
      var ext = this.checklist.file.type.replace(/(.*)\//g, '')
      fd.append(
        'calibrationchecklistfile',
        this.checklist.file,
        `${this.checklist.calibrationID}.${ext}`
      )

      await UploadService.createCalibrationChecklist(fd)
        .then((res) => {
          // this.snackbar('Success! The checklist was uploaded successfully', 'success')

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)
          this.snackbar(
            'Error! There was an error uploading the checklist.',
            'error',
            '6000'
          )

          return new Promise((resolve) => {
            resolve('Done')
          })
        })

      await CalibrationService.update(this.checklist.calibrationID, {
        checklistDate: new Date().toISOString()
      })
        .then(async (response) => {
          this.snackbar(
            'Success! Calibration ticket was marked complete',
            'success'
          )
          this.dialogChecklist = false
          await this.retrieveCalibrations()

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openInventoryOutDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.inventoryOut) {
        this.inventoryOut = this.editedItem.calibration.inventoryOut
      }

      this.inventoryOut.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogInventoryOut = true
    },

    async saveInventoryOut() {
      this.saving.show = true
      if (this.inventoryOut.calibrationInventoryOutID) {
        await CalibrationInventoryOutService.update(
          this.inventoryOut.calibrationInventoryOutID,
          this.inventoryOut
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Inventory Out saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationInventoryOutService.create(this.inventoryOut)
          .then((response) => {
            this.inventoryOut.calibrationInventoryOutID =
              response.data.calibrationInventoryOutID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Inventory In saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    async completeInventoryOut() {
      await this.saveInventoryOut()
      await CalibrationService.update(this.inventoryOut.calibrationID, {
        inventoryOutDate: new Date().toISOString()
      })
        .then(async (response) => {
          await CalibrationInventoryOutService.emailPerform(
            this.inventoryOut.calibrationInventoryOutID
          )
            .then(async (response) => {
              this.snackbar(
                'Success! Inventory Out was marked complete',
                'success'
              )
              this.dialogInventoryOut = false
              await this.retrieveCalibrations()

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((e) => {
              this.snackbar(
                'Error! There was an error sending the internal perform complete email.',
                'error',
                '6000'
              )
              console.log(e)
            })

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          this.snackbar(
            'Error! There was an error marking Inventory Out complete.',
            'error',
            '6000'
          )
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    async openFulfillDialog(item) {
      this.editedIndex = this.lols.indexOf(item)
      this.editedItem = Object.assign({}, item)

      if (this.editedItem.calibration.order) {
        this.fulfill = this.editedItem.calibration.order

        if (this.fulfill.fulfilledByID) {
          await AuthService.get(this.fulfill.fulfilledByID).then((response) => {
            this.fulfill.fulfilledBy = response.data.fullName

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
        }
        if (this.fulfill.fulfillDate) {
          this.fulfill.fulfillDateShow = this.fulfill.fulfillDate
            .substring(0, 10)
            .replaceAll('-', '/')
        }
      }

      this.fulfill.calibrationID = this.editedItem.calibration.calibrationID
      this.dialogFulfill = true
    },

    async saveFulfill() {
      this.saving.show = true
      if (this.fulfill.fulfillPhoneNotes && !this.fulfill.fulfillPhoneDate) {
        var date = new Date()
        this.fulfill.fulfillPhoneDate = date.toISOString()
      }
      if (this.fulfill.calibrationOrderID) {
        await CalibrationOrderService.update(
          this.fulfill.calibrationOrderID,
          this.fulfill
        )
          .then(() => {
            this.saving.show = false
            this.saving.icon = 'mdi-check'
            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Fulfill saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      } else {
        CalibrationOrderService.create(this.fulfill)
          .then((response) => {
            this.fulfill.calibrationOrderID = response.data.calibrationOrderID

            this.saving.show = false
            this.saving.icon = 'mdi-check'

            var _this = this
            setTimeout(function() {
              _this.saving.icon = 'mdi-content-save-outline'
            }, 3000)
            this.snackbar('Success! Fulfill saved.', 'success')

            return new Promise((resolve) => {
              resolve('Done')
            })
          })
          .catch((e) => {
            console.log(e)
            this.saving.show = false
          })
      }
    },

    async completeFulfill() {
      await this.saveFulfill()

      if (!this.fulfill.shipVia) {
        this.snackbar('Error! Ship Via cannot be left blank.', 'error')
        return
      }

      if (!this.fulfill.trackingNumber) {
        this.snackbar('Error! Tracking Number cannot be left blank.', 'error')
        return
      }

      if (!this.fulfill.fulfillPhoneNotes) {
        this.snackbar('Error! Phone Notes cannot be left blank.', 'error')
        return
      }

      if (!this.fulfill.fulfilledBy) {
        this.snackbar('Error! Fulfill By cannot be left blank.', 'error')
        return
      }

      var fulfillComplete
      if (!this.editedItem.calibration.calibrationSwap) {
        fulfillComplete = {
          fulfillDate: new Date().toISOString(),
          completeDate: new Date().toISOString()
        }
      } else {
        fulfillComplete = {
          fulfillDate: new Date().toISOString()
        }
      }

      await CalibrationService.update(
        this.fulfill.calibrationID,
        fulfillComplete
      )
        .then(async (response) => {
          await CalibrationOrderService.emailFulfill(
            this.fulfill.calibrationOrderID
          )
            .then(async (response) => {
              this.snackbar('Success! Fulfill was marked complete', 'success')
              this.dialogFulfill = false
              await this.retrieveCalibrations()

              return new Promise((resolve) => {
                resolve('Done')
              })
            })
            .catch((e) => {
              this.snackbar(
                'Error! There was an error sending the fulfillment confirmation email.',
                'error',
                '6000'
              )
              console.log(e)
            })

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
        .catch((e) => {
          this.snackbar(
            'Error! There was an error marking fulfill complete.',
            'error',
            '6000'
          )
          console.log(e)

          return new Promise((resolve) => {
            resolve('Done')
          })
        })
    },

    openDialogMarkComplete(step) {
      this.markCompleteStep = step
      this.dialogMarkComplete = true
    },

    markComplete() {
      if (this.markCompleteStep == 'recallTicket') {
        this.completeRecallTicket()
      } else if (this.markCompleteStep == 'receiving') {
        this.completeReceiving()
      } else if (this.markCompleteStep == 'order') {
        this.completeOrder()
      } else if (this.markCompleteStep == 'inventoryIn') {
        this.completeInventoryIn()
      } else if (this.markCompleteStep == 'serviceTicket') {
        this.completeServiceTicket()
      } else if (this.markCompleteStep == 'calibrationTicket') {
        this.completeCalibrationTicket()
      } else if (this.markCompleteStep == 'checklist') {
        this.completeChecklist()
      } else if (this.markCompleteStep == 'inventoryOut') {
        this.completeInventoryOut()
      } else if (this.markCompleteStep == 'fulfill') {
        this.completeFulfill()
      }
      this.dialogMarkComplete = false
    },

    snackbar(message, color, timeout) {
      window._LOL2P.$emit('SHOW_SNACKBAR', {
        text: message,
        color: color,
        timeout: timeout
      })
    },

    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    }
  }
}
</script>
